const fake = {
    "id": 3,
    "touchpoints": [{
        "index": 1,
        "name": "L'emplacement, le quartier sont fantastiques.",
        "shortName": "L'emplacement, le quartier sont fantastiques.",
        "stage": "ACCÈS AU STARBUCKS",
        "occurence": 4.6,
        "positiveIntensity": 195,
        "negativeIntensity": 0,
        "average": 169,
        "positiveVerbatim": ["L'emplacement ! L'emplacement ! Wow ! Juste en face de ces sculptures de lions.", "Superbe vue sur Michigan Ave. Près du parc. Personnel sympa !", "Super emplacement. Bonnes ondes… Les employés font le job."],
        "negativeVerbatim": [],
        "upperSignalType": " ",
        "lowerSignalType": null,
        "i": 0
    }, {
        "index": 2,
        "name": "Ce Starbucks est près de chez moi ou de mon bureau / trop éloigné.",
        "shortName": "Ce Starbucks est près de chez moi ou de mon bureau / trop éloigné.",
        "stage": "ACCÈS AU STARBUCKS",
        "occurence": 1.5,
        "positiveIntensity": 129,
        "negativeIntensity": -121,
        "average": 65,
        "positiveVerbatim": [],
        "negativeVerbatim": [],
        "upperSignalType": " ",
        "lowerSignalType": null,
        "i": 1
    }, {
        "index": 3,
        "name": "Le parking est / n'est pas pratique.",
        "shortName": "Le parking est / n'est pas pratique.",
        "stage": "ACCÈS AU STARBUCKS",
        "occurence": 4.2,
        "positiveIntensity": 168,
        "negativeIntensity": -92,
        "average": -8,
        "positiveVerbatim": ["C'est un \"Bucky\" plutôt cool où on peut se garer. A l'intérieur d'un centre commercial, donc plein de places de parking !", "Lieu de rendez-vous parfait. Et juste à côté du parking.", "Parking gratuit, ce qui est exceptionnel pour le quartier."],
        "negativeVerbatim": [],
        "upperSignalType": " ",
        "lowerSignalType": null,
        "i": 2
    }, {
        "index": 4,
        "name": "J'apprécie les horaires d'ouverture tardive.",
        "shortName": "J'apprécie les horaires d'ouverture tardive.",
        "stage": "ACCÈS AU STARBUCKS",
        "occurence": 4.5,
        "positiveIntensity": 199,
        "negativeIntensity": 0,
        "average": 133,
        "positiveVerbatim": [],
        "negativeVerbatim": [],
        "upperSignalType": " ",
        "lowerSignalType": null,
        "i": 3
    }, {
        "index": 5,
        "name": "En tant qu'handicapé, je me sens / ne me sens pas le bienvenu.",
        "shortName": "En tant qu'handicapé, je me sens / ne me sens pas le bienvenu.",
        "stage": "ACCÈS AU STARBUCKS",
        "occurence": 0.5,
        "positiveIntensity": 53,
        "negativeIntensity": -244,
        "average": -93,
        "positiveVerbatim": [],
        "negativeVerbatim": ["D'après la loi \"Americans with Disabilities Act\", je suis autorisé à amener mon animal d'assistance dans tout lieu ouvert à tous. Ce qui signifie que je peux amener mon chien d'assistance dans un Starbucks, ici à Sacramento, Califormie. On m'a demandé de sortir mon animal et de l'attacher au rack de vélos, dans le patio à côté du parking. Cela signifie que je peux techniquement engager des poursuites à l'encontre de Starbucks, car mon animal est en règle, avec son gilet, ses plaques d'identité et ses papiers. J'en ai assez et je suis fatigué de me voir interdire l'accès de mon chien, dont j'ai absolument besoin à cause de mon PTSD, TBI, et SDD. C'est de la discrimination !!"],
        "upperSignalType": null,
        "lowerSignalType": "weakness",
        "i": 4
    }, {
        "index": 6,
        "name": "J'adore ce Starbucks en particulier / ce Starbucks n'est pas au niveau.",
        "shortName": "J'adore ce Starbucks en particulier / ce Starbucks n'est pas au niveau.",
        "stage": "ATMOSPHÈRE & DESIGN",
        "occurence": 35.4,
        "positiveIntensity": 178,
        "negativeIntensity": -147,
        "average": 30,
        "positiveVerbatim": [],
        "negativeVerbatim": [],
        "upperSignalType": " ",
        "lowerSignalType": null,
        "i": 5
    }, {
        "index": 7,
        "name": "On se sent bien dans ce Starbucks / l'atmosphère est désagréable.",
        "shortName": "On se sent bien dans ce Starbucks / l'atmosphère est désagréable.",
        "stage": "ATMOSPHÈRE & DESIGN",
        "occurence": 7.9,
        "positiveIntensity": 209,
        "negativeIntensity": -219,
        "average": 169,
        "positiveVerbatim": ["Il y a un truc dans leur façon d'agencer les tables, chaises, canapés, etc, qui rend l'atmosphère géniale. ", "C'est de loin, mon Starbucks intramuros préféré. Des ondes tellement positives et un café incroyable. 🤙🏼☕.", "Starbucks mignon et très animé, juste en face de l'Art Institute. Bonne ambiance avec cet esprit de Chicago en plus. ", "Comment peut-on être émotionnellement attaché à un Starbucks ? Et bien quand ce Starbucks était l'ancien bowling sympa de votre quartier. Et c'est le cas. C'est un Starbucks classique, mais avec un truc différent. Un peu plus grand que le Starbucks de base, et avec des détails architecturaux typiques qui respectent parfaitement la structure et l'esprit d'origine.  "],
        "negativeVerbatim": [],
        "upperSignalType": "strength",
        "lowerSignalType": "weakness",
        "i": 6
    }, {
        "index": 8,
        "name": "L'endroit est magnifique / je n'aime pas la déco.",
        "shortName": "L'endroit est magnifique / je n'aime pas la déco.",
        "stage": "ATMOSPHÈRE & DESIGN",
        "occurence": 2.6,
        "positiveIntensity": 224,
        "negativeIntensity": -96,
        "average": 51,
        "positiveVerbatim": ["J'adore ce Starbucks. De grandes tables, plein d'espaces différents pour s'asseoir et un personnel sympa ! Et l'inscription murale peinte à la main est tellement belle !", "C'est le meilleur Starbucks d'Atlanta. Ils sont rapides, polis, et sympas. Et le bâtiment lui même est magnifique.", "C'est un Starbucks Reserve et probablement le plus cool et le plus chic d'Atlanta. On peut commander des cafés originaux, lire la presse française et d'autres trucs que l'on n'a pas dans les Sbux classiques. Des suspensions en cuivre, une jolie carte du monde, des sièges à l’extérieur, des sièges au bar, c’est totalement atypique pour un Starbucks et ça vaut le détour.", "Très joliment décoré, vue incroyable. C'est le meilleur Starbucks dans lequel je sois jamais allé."],
        "negativeVerbatim": [],
        "upperSignalType": "goodPractice",
        "lowerSignalType": null,
        "i": 7
    }, {
        "index": 9,
        "name": "J'adore l'odeur du café quand je pousse la porte.",
        "shortName": "J'adore l'odeur du café quand je pousse la porte.",
        "stage": "ATMOSPHÈRE & DESIGN",
        "occurence": 0.4,
        "positiveIntensity": 212,
        "negativeIntensity": 0,
        "average": 173,
        "positiveVerbatim": ["Quand vous poussez la porte et que l'odeur du café du jour vous saisit, vous réalisez immédiatement qu'il s'agit d'une expérience unique. À chaque tournant, vos sens sont séduits par des textures chaleureuses, des images, des goûts et des odeurs luxueux. C'est bien là que les boissons à base de café sont si soigneusement préparées... ", "L'odeur et l'atmosphère de la boutique sont incroyables. Apaisant, énergisant et délicieux. "],
        "negativeVerbatim": [],
        "upperSignalType": "goodPractice",
        "lowerSignalType": null,
        "i": 8
    }, {
        "index": 10,
        "name": "Il y a beaucoup d'espace et de places assises disponibles / je ne trouve pas de place assise.",
        "shortName": "Il y a de l'espace, des places assises / je ne trouve pas de place assise.",
        "stage": "ATMOSPHÈRE & DESIGN",
        "occurence": 6.7,
        "positiveIntensity": 309,
        "negativeIntensity": -64,
        "average": 255,
        "positiveVerbatim": ["L'un des plus grands Starbucks que j'aie jamais vus. Plein d'espaces différents pour se rencontrer, discuter - tables, bancs, tabourets de bar et fauteuils.", "C'est le plus joli que j'aie jamais vu. Plus propre que beaucoup d'autres endroits et plein d'espace pour étudier contrairement aux \"placards\" des Starbucks habituels.", "J'adore le Starbucks près de NYU. Il est immense avec un super espace pour s'asseoir près des grandes vitres. "],
        "negativeVerbatim": [],
        "upperSignalType": "strength",
        "lowerSignalType": null,
        "i": 9
    }, {
        "index": 11,
        "name": "Il y a différents espaces agencés avec différentes ambiances.",
        "shortName": "Il y a différents espaces agencés avec différentes ambiances.",
        "stage": "ATMOSPHÈRE & DESIGN",
        "occurence": 1.7,
        "positiveIntensity": 160,
        "negativeIntensity": 0,
        "average": 137,
        "positiveVerbatim": [],
        "negativeVerbatim": [],
        "upperSignalType": " ",
        "lowerSignalType": null,
        "i": 10
    }, {
        "index": 12,
        "name": "J'apprécie le confort / je ne trouve de place confortable et calme.",
        "shortName": "J'apprécie le confort / je ne trouve de place confortable et calme.",
        "stage": "ATMOSPHÈRE & DESIGN",
        "occurence": 6.4,
        "positiveIntensity": 197,
        "negativeIntensity": -155,
        "average": 123,
        "positiveVerbatim": ["Je suis accro à Starbucks. Celui là sur California St. à Laurel Heights Village est bondé. J'ai réussi à mettre la main sur un fauteuil en cuir super confortable pour siroter mon Latte !", "Ils avaient plein de tables de tailles différentes et aussi de gros fauteuils confortables. Les toilettes étaient immaculées."],
        "negativeVerbatim": ["C'est déplorable que les personnes qui veulent s'asseoir, commander un bon repas avec café et sandwich, ne trouvent aucune place. Même les places réservées aux handicapés sont occupées par des étudiants qui ressemblent à des athlètes olympiques. Et le personnel s'en fiche. ", "Le plus gros inconvenient : les gens (souvent jeunes et en bonne santé) occupent un siège sans consommer. Et il y a trop peu de sièges adaptés aux personnes âgées (chaises avec dossier, de hauteur normale pour que vos pieds puissent toucher le sol)."],
        "upperSignalType": null,
        "lowerSignalType": "weakness",
        "i": 11
    }, {
        "index": 13,
        "name": "Je peux faire une vraie pause / il y a trop de monde pour se relaxer.",
        "shortName": "Je peux faire une vraie pause / il y a trop de monde pour se relaxer.",
        "stage": "ATMOSPHÈRE & DESIGN",
        "occurence": 4.3,
        "positiveIntensity": 310,
        "negativeIntensity": -147,
        "average": 236,
        "positiveVerbatim": ["Endroit parfait pour débrancher.", "J'adore cet endroit. Ça me permet de décrocher de tout le monde. C'est mon endroit à moi. ", "Bon pit stop après une séance de shopping sur Henderson."],
        "negativeVerbatim": [],
        "upperSignalType": "goodPractice",
        "lowerSignalType": null,
        "i": 12
    }, {
        "index": 14,
        "name": "C'est propre / sale, ou pas entretenu au fil de la journée.",
        "shortName": "C'est propre / sale, ou pas entretenu au fil de la journée.",
        "stage": "ATMOSPHÈRE & DESIGN",
        "occurence": 7.6,
        "positiveIntensity": 236,
        "negativeIntensity": -122,
        "average": 9,
        "positiveVerbatim": ["J'adore la vue sur l'animation de Michigan Ave depuis cet endroit. Il n'y a que de bonnes ondes, notemment grâce à la propreté du lieu.", "Endroit propre, bonnes ondes.", "Celui-là était très propre, bien organisé, le comptoir avec le sucre et les produits laitiers bien fourni. "],
        "negativeVerbatim": [],
        "upperSignalType": "goodPractice",
        "lowerSignalType": null,
        "i": 13
    }, {
        "index": 15,
        "name": "Les toilettes sont agréables et propres / sales.",
        "shortName": "Les toilettes sont agréables et propres / sales.",
        "stage": "ATMOSPHÈRE & DESIGN",
        "occurence": 2.5,
        "positiveIntensity": 222,
        "negativeIntensity": -149,
        "average": 39,
        "positiveVerbatim": [],
        "negativeVerbatim": [],
        "upperSignalType": "goodPractice",
        "lowerSignalType": null,
        "i": 14
    }, {
        "index": 16,
        "name": "Le wi-fi est rapide / lent.",
        "shortName": "Le wi-fi est rapide / lent.",
        "stage": "ATMOSPHÈRE & DESIGN",
        "occurence": 2.4,
        "positiveIntensity": 232,
        "negativeIntensity": -8,
        "average": 194,
        "positiveVerbatim": ["Super service, le wi-fi est rapide tout comme le service. Super expérience comme toujours.", "L'atmosphère à l'intérieur et le personnel sont sympa. Internet marche parfaitement. Et bien sûr le café Starbucks. "],
        "negativeVerbatim": [],
        "upperSignalType": "goodPractice",
        "lowerSignalType": null,
        "i": 15
    }, {
        "index": 17,
        "name": "Il y a plein de prises electriques.",
        "shortName": "Il y a plein de prises electriques.",
        "stage": "ATMOSPHÈRE & DESIGN",
        "occurence": 1.8,
        "positiveIntensity": 216,
        "negativeIntensity": 0,
        "average": 147,
        "positiveVerbatim": [],
        "negativeVerbatim": [],
        "upperSignalType": " ",
        "lowerSignalType": null,
        "i": 16
    }, {
        "index": 18,
        "name": "C'est un endroit parfait pour travailler ou étudier / il y a trop de monde pour travailler.",
        "shortName": "Un endroit parfait pour travailler / il y a trop de monde pour travailler.",
        "stage": "ATMOSPHÈRE & DESIGN",
        "occurence": 1.6,
        "positiveIntensity": 234,
        "negativeIntensity": -50,
        "average": 125,
        "positiveVerbatim": ["Ce Starbucks est immense, avec une atmosphère vraiment cool et décontractée, où on peut se faire une séance de rattrapage entre copains ou travailler, seul avec son ordinateur. On se sent vraiment à l'aise.", "Grand Starbucks 24/24. Super endroit pour coder la nuit !", "Mon lieu n°1 après le bureau pour utiliser le wi-fi gratuit et plein d'espace pour bien avancer dans son travail. "],
        "negativeVerbatim": [],
        "upperSignalType": "goodPractice",
        "lowerSignalType": null,
        "i": 17
    }, {
        "index": 19,
        "name": "Je me sens en sécurité / un client désagréable crée un sentiment d'insécurité.",
        "shortName": "Je me sens en sécurité / je ne me sens pas en sécurité.",
        "stage": "ATMOSPHÈRE & DESIGN",
        "occurence": 1.3,
        "positiveIntensity": 88,
        "negativeIntensity": -97,
        "average": -61,
        "positiveVerbatim": [],
        "negativeVerbatim": [],
        "upperSignalType": " ",
        "lowerSignalType": null,
        "i": 18
    }, {
        "index": 20,
        "name": "J'adore la terrasse ou le patio.",
        "shortName": "J'adore la terrasse ou le patio.",
        "stage": "ATMOSPHÈRE & DESIGN",
        "occurence": 1.8,
        "positiveIntensity": 232,
        "negativeIntensity": 0,
        "average": 157,
        "positiveVerbatim": ["L'emplacement sur le \"Trail\" est l'un des meilleurs. Salle immense, tables et chaises confortables, et une grande terrasse à l'extérieur, avec le système parfait pour filtrer la chaleur de l'Arizona.", "De grandes fenêtres, beaucoup de lumière. Des tables à l'extérieur et des fenêtres pour apprécier le lieu pendant les belles journées de printemps. ", "J'adore l'espace extérieur. C'est la meilleure vue. "],
        "negativeVerbatim": [],
        "upperSignalType": "goodPractice",
        "lowerSignalType": null,
        "i": 19
    }, {
        "index": 21,
        "name": "J'adore la vue depuis ce Starbucks.",
        "shortName": "J'adore la vue depuis ce Starbucks.",
        "stage": "ATMOSPHÈRE & DESIGN",
        "occurence": 1.3,
        "positiveIntensity": 276,
        "negativeIntensity": 0,
        "average": 257,
        "positiveVerbatim": ["Un café avec une vue sur le Hard Rock Café, Bubba Gump Shrimp et le siège de la NYPD. Que demander de plus ? ", "On est venu quasiment tous les jours pour prendre une boisson fraîche. L'emplacement est exceptionnel avec des tables et des parasols dehors et une vue sur le parc et l'océan.", "Magnifiquement décoré, vue époustouflante. Le meilleur Starbucks où je sois jamais allé.", "Ce Starbucks est un super endroit pour faire une pause quand on est sur Lincoln Road. Il y a des tables à l'extérieur, donc on peut regarder les passants tout en sirotant sa boisson."],
        "negativeVerbatim": [],
        "upperSignalType": "goodPractice",
        "lowerSignalType": null,
        "i": 20
    }, {
        "index": 22,
        "name": "Les autres clients sont agréables / sont une nuisance.",
        "shortName": "Les autres clients sont agréables / sont une nuisance.",
        "stage": "ATMOSPHÈRE & DESIGN",
        "occurence": 0.4,
        "positiveIntensity": 296,
        "negativeIntensity": -101,
        "average": 256,
        "positiveVerbatim": ["Les clients, baristas, et les gens qui essayent juste de faire leur travail sont toujours positifs, polis, enthousiastes. C'est un tel plaisir de venir ici ! Sans conteste le meilleur 🌟 Starbucks à Miami. 🙌.", "En plus des gens cool qui travaillent ici, je dois dire que ce sont les locaux comme moi qui font ce charme tout particulier. Nous, les Crenshaw-nites, sommes vraiment des gens cool. Contrairement au Starbucks Magic Johnson à Ladera, celui-ci n'est pas conçu comme un club, bondé les vendredis et samedis soirs. Il y a juste suffisamment de gens pour créer un bruit d'ambiance qui va parfaitement avec le bruit des machines à café. J'espère que ce Starbucks ne fermera jamais. C'est mon chouchou ! C'est ma maison ! Lol.", "Merveilleux endroit pour regarder les gens. Endroit qui plait aux jeunes actifs, aux étudiants, aux entrepreneurs, mères de famille, célibataires et gens bien du quartier. Plein de célibataires qui cherchent à socialiser. Fortement recommandé.", "L'ambiance est tellement professionnelle. Quand je viens ici, je prends un Mocha et je lis mes emails. Ce Starbucks m'apporte un sentiment de sérénité."],
        "negativeVerbatim": [],
        "upperSignalType": "goodPractice",
        "lowerSignalType": null,
        "i": 21
    }, {
        "index": 23,
        "name": "Starbucks est trop élitiste.            ",
        "shortName": "Starbucks est trop élitiste.            ",
        "stage": "ATMOSPHÈRE & DESIGN",
        "occurence": 0.4,
        "positiveIntensity": 0,
        "negativeIntensity": -148,
        "average": -107,
        "positiveVerbatim": [],
        "negativeVerbatim": ["Les employés semblent avoir la même attitude élitiste que le PDG et la Direction Générale de la société. Que quelqu'un dépense 5 $ pour un café m'échappe. Pour 5 $, je peux avoir une livre de grains de café, les stocker dans un récipient sous vide et moudre du café frais tous les matins."],
        "upperSignalType": " ",
        "lowerSignalType": null,
        "i": 22
    }, {
        "index": 24,
        "name": "Le service est rapide / il y a des dysfonctionnements.",
        "shortName": "Le service est rapide / il y a des dysfonctionnements.",
        "stage": "COMMANDE",
        "occurence": 19.3,
        "positiveIntensity": 75,
        "negativeIntensity": -74,
        "average": -20,
        "positiveVerbatim": ["Service rapide, même quand il y a une affluence \"à la Starbucks\". ", "Il y a en général plein de monde, mais ils sont rapides et votre commande est prête le temps de le dire."],
        "negativeVerbatim": ["Je suis entré et j'ai commandé un grand Caffe Latte avec du lait de soja. J'ai attendu plus de 15 minutes et j'ai dû partir sans ma boisson. Très mécontent.", "Ma fille de 16 ans était deuxième dans la file, a commandé et payé sa boisson. Plusieurs personnes sont venues après elle, ont commandé leurs boissons et sont parties avant qu'elle ne la reçoive. (…) J'ai contacté ce Starbucks pour savoir ce qui s'était passé. Pas une seule fois dans la conversation, la dame ne s'est excusée ni n'a semblée concernée."],
        "upperSignalType": " ",
        "lowerSignalType": null,
        "i": 23
    }, {
        "index": 25,
        "name": "Le système de commande est simple et fluide / ma commande ne se passe pas bien.",
        "shortName": "Le système de commande est / n'est pas simple et fluide.",
        "stage": "COMMANDE",
        "occurence": 10.8,
        "positiveIntensity": 89,
        "negativeIntensity": -81,
        "average": -45,
        "positiveVerbatim": [],
        "negativeVerbatim": [],
        "upperSignalType": " ",
        "lowerSignalType": null,
        "i": 24
    }, {
        "index": 26,
        "name": "Bien qu'il y ait du monde, les files attentes avancent vite / j'attends trop longtemps.",
        "shortName": "Les files attentes avancent vite / j'attends trop longtemps.",
        "stage": "COMMANDE",
        "occurence": 18.7,
        "positiveIntensity": 137,
        "negativeIntensity": -88,
        "average": -27,
        "positiveVerbatim": ["J'ai été surpris. D'abord, la boisson était parfaitement préparée, avec pile le goût que j'attendais, et très rapidement compte-tenu du monde présent dans le magasin. ", "J'aime cet endroit. Les gens qui travaillent ici sont incroyables ! Avec cette foule toute la journée, ils restent toujours sympas et souriants. Les cafés et la nourriture arrivent vite.  ", "Ils font un super boulot pour garder le rythme avec cette affluence. Il ont un personnel sympathique."],
        "negativeVerbatim": ["Personnel très démotivé. Si vous entrez dans n'importe quel Starbucks, vous rencontrerez une brochette de \"nerds\" à la cool, sans aucune conscience de la valeur du temps des clients. ", "Je suis toujours allé dans ce SB et depuis peu, il y a de nouveaux employés deplorables. J'ai fait la queue pendant 20 minutes seulement pour m'entendre dire qu'ils n'avaient plus de café glacé. Il fait 32°C à l'extérieur. Ne pensez-vous pas que vous devriez planifier et préparer du café glacé ?"],
        "upperSignalType": "priority",
        "lowerSignalType": null,
        "i": 25
    }, {
        "index": 27,
        "name": "L'appli est géniale pour éviter l'attente / on se fait doubler par les commandes sur mobile.",
        "shortName": "L'appli est géniale  / on se fait doubler par les commandes sur mobile.",
        "stage": "COMMANDE",
        "occurence": 4.5,
        "positiveIntensity": 98,
        "negativeIntensity": -189,
        "average": -49,
        "positiveVerbatim": ["Mon Starbucks préféré ! Avec les commandes sur mobile, c'est tellement facile d'avoir ma dose de café du matin !"],
        "negativeVerbatim": ["C’est exactement ce que je craignais : les personnes qui ont les moyens de se payer un smartphone doublent toutes les files d'attente et sont servis les premiers.", "Avez-vous fait l'expérience d'aller dans un Starbucks et de passer votre commande, puis de la voir placée en bas de la liste pour que les commandes passées par mobile soient prioritaires ? Ça ne démontre pas vraiment un sens aigu du client. J'ai attendu 20 minutes pour avoir ma boisson, alors que c'était une journée calme sans grande affluence. Il me semble que les employés devraient également prendre en compte le temps d'attente des clients qui sont dans le magasin... Très frustrant ! J'envisage de chercher un café plus soucieux de ses clients, après des années de fidélité à Starbucks..."],
        "upperSignalType": null,
        "lowerSignalType": "weakness",
        "i": 26
    }, {
        "index": 28,
        "name": "Ils ont mal écrit mon nom sur le gobelet.",
        "shortName": "Ils ont mal écrit mon nom sur le gobelet.",
        "stage": "COMMANDE",
        "occurence": 0.4,
        "positiveIntensity": 0,
        "negativeIntensity": -88,
        "average": -13,
        "positiveVerbatim": [],
        "negativeVerbatim": [],
        "upperSignalType": " ",
        "lowerSignalType": null,
        "i": 27
    }, {
        "index": 29,
        "name": "On m'offre des petits plus / il y a trop d'extras payants.",
        "shortName": "On m'offre des petits plus / il y a trop d'extras payants.",
        "stage": "COMMANDE",
        "occurence": 1.7,
        "positiveIntensity": 113,
        "negativeIntensity": -188,
        "average": -12,
        "positiveVerbatim": [],
        "negativeVerbatim": ["J'ai commandé deux thés glacés et précisé sans eau ni sirop, mais j'ai demandé plus de glaçons. L'employée a pris la commande et m'a ensuite annoncé qu'elle devrait me facturer 75 cents de plus pour chaque boisson parce que j'avais demandé sans eau. 1.50 $ pour PAS d'eau !!", "Je commande tous les matins, et à nouveau la plupart des après-midis, un Grande Americano avec supplément crème et Splenda. En règle générale, le barista met environ 2 cm de crème dans mon verre comme je le demande, ce qui est parfait. Lors de ma visite le matin du 4 août, l’employé m'a informé qu’il facturerait 0,60 $ pour le supplément crème. (...) Si je commande sur l'application et demande un supplément crème, l’application me facture le prix normal, alors pourquoi me facturerait-on un supplément alors que l’application ne le fait pas ? (...) Ma fidélité envers Starbucks pendant toutes ces années reposait sur de nombreux facteurs, mais deux facteurs importants étaient le service et la cohérence."],
        "upperSignalType": null,
        "lowerSignalType": "weakness",
        "i": 28
    }, {
        "index": 30,
        "name": "L'employé au paiement est sympathique / le paiement se passe mal.",
        "shortName": "L'employé au paiement est sympathique / le paiement se passe mal.",
        "stage": "COMMANDE",
        "occurence": 2,
        "positiveIntensity": 176,
        "negativeIntensity": -109,
        "average": -45,
        "positiveVerbatim": [],
        "negativeVerbatim": [],
        "upperSignalType": " ",
        "lowerSignalType": null,
        "i": 29
    }, {
        "index": 31,
        "name": "L'offre promotionnelle en cours m'est refusée.",
        "shortName": "L'offre promotionnelle en cours m'est refusée.",
        "stage": "COMMANDE",
        "occurence": 1,
        "positiveIntensity": 0,
        "negativeIntensity": -97,
        "average": -50,
        "positiveVerbatim": [],
        "negativeVerbatim": ["J'ai juste essayé d'utiliser le coupon que j'ai eu au Starbucks de Havertown PA. 50% de remise sur un article du menu déjeuner après 11h (il est 14h). On m'a dit qu'on ne pouvait pas appliquer le coupon. Oui, ils les ont donnés, mais ils ne les acceptent pas. Quelle est cette manière de traiter les clients ?"],
        "upperSignalType": " ",
        "lowerSignalType": null,
        "i": 30
    }, {
        "index": 32,
        "name": "Je donne toujours un pourboire aux baristas pour leur travail difficile.",
        "shortName": "Je donne toujours un pourboire aux baristas pour leur travail difficile.",
        "stage": "COMMANDE",
        "occurence": 0.4,
        "positiveIntensity": 98,
        "negativeIntensity": 0,
        "average": 60,
        "positiveVerbatim": [],
        "negativeVerbatim": [],
        "upperSignalType": " ",
        "lowerSignalType": null,
        "i": 31
    }, {
        "index": 33,
        "name": "J'ai un échange agréable / désagréable avec un employé.",
        "shortName": "J'ai un échange agréable / désagréable avec un employé.",
        "stage": "INTERACTIONS AVEC LE PERSONNEL",
        "occurence": 30,
        "positiveIntensity": 172,
        "negativeIntensity": -99,
        "average": 20,
        "positiveVerbatim": ["Votre employée Lucy était extrêmement sympathique et savait exactement comment je voulais mon café. La boutique était propre, et tout le monde était chaleureux. Croyez-moi, je vais devenir un fidèle de ce Starbucks. ", "Il y a un nouveau gars, Mario. Il est rapide et a un super sens du service. Continue à sourire Mario. Ça nous fait la journée !", "Tous les dimanches matins je vais dans ce Starbucks près de notre église et je suis toujours aussi enchanté par le service et le café.  Jameslyn est formidable. Elle sait toujours parfaitement comment j'aime mon café et me demande toujours des nouvelles de ma semaine. Elle, et les autres membres du personnel, sont super chaleureux. "],
        "negativeVerbatim": ["Alexis du Starbucks est tellement désagréable à chaque fois que j'y vais. Elle vous donne l'impression que vous la dérangez quand vous commandez une boisson. La direction devrait se débarrasser d'elle. Mauvaise expérience. Je n'y retournerai jamais !", "Je vois des employés trop occupés à parler de ce qu'ils ont fait la veille au soir pour prêter attention à un client…"],
        "upperSignalType": "priority",
        "lowerSignalType": null,
        "i": 32
    }, {
        "index": 34,
        "name": "Les baristas sont / ne sont pas sympathiques.",
        "shortName": "Les baristas sont / ne sont pas sympathiques.",
        "stage": "INTERACTIONS AVEC LE PERSONNEL",
        "occurence": 23.1,
        "positiveIntensity": 240,
        "negativeIntensity": -113,
        "average": 13,
        "positiveVerbatim": ["Service chaleureux et le personnel fait l'effort d'essayer de nous connaître.", "C'est comme aller chez un ami tous les week-ends. ", "Ce Starbucks est super ! Je suis un peu influencée dans le sens où Bee (je crois qu'elle est superviseur) remarque toujours quand je je fais attention à ma santé dans mes choix et fait des remarques sur ma perte de poids. La plupart des gens de ma famille proche et de mes amis n'ont même pas remarqué. ", "J'aime le fait que les gens derrière le comptoir semblent avoir une relation avec les clients, ce qui crée un sentiment de communauté."],
        "negativeVerbatim": ["Plus souvent que rarement, l'employé me tend ma boisson et je suis le seul à remercier. Comment se fait-il que la seule personne qui dise merci dans ce scénario est le client ? Ne devrait-ce pas être l'inverse ?", "Quand je mets un pourboire dans le bocal, ils ont déjà tourné le dos sans un \"merci\". Que le magasin soit plein ou peu rempli, le service client a plongé vers le service zéro.", "La barista était pressée, je n'ai pas eu droit à un bonjour. Et mon ami et moi avons remarqué que la fille était en train de rassembler les chaises et les tables à 19h45. Elle m'a dit que je ne pouvais pas m'asseoir parce qu'elle empilait les tables, alors je me suis assis sur le rebord du trottoir. Elle n'était pas aimable et elle semblait impatiente de nous voir partir dès 20h25."],
        "upperSignalType": "priority",
        "lowerSignalType": null,
        "i": 33
    }, {
        "index": 35,
        "name": "Je suis bien accueilli / on m'ignore.",
        "shortName": "Je suis bien accueilli / on m'ignore.",
        "stage": "INTERACTIONS AVEC LE PERSONNEL",
        "occurence": 6.4,
        "positiveIntensity": 68,
        "negativeIntensity": -163,
        "average": 46,
        "positiveVerbatim": [],
        "negativeVerbatim": ["Il y a 6 ou 7 employés qui travaillent, la file est courte mais tous les employés servent les clients du Drive, nous ignorant totalement. Même quand nous nous faisons entendre, ils sont impolis et nous ignorent.", "Il y avait une personne devant moi qui s'est fait servir par une fille, qui échangeait avec elle, sans me remarquer. Une autre personne est venue derrière moi, et voulait aussi un café. Elle en a eu marre d'attendre et est sortie. Mais qui est cette jeune femme et pourquoi travaille-t-elle encore ici ? Elle a été tellement impolie.", "Je suis allé au Starbucks de San Antonio sur Bitters Road et je me suis assis pour y prendre ma boisson. Il n'y avait personne d'autre dans la file et ils prenaient commande après commande pour le Drive et pendant ce temps, j'attendais et attendais encore. Je ne retournerai jamais là où les clients de la salle sont ignorés.", "Ils avaient pour habitude de me saluer et de me servir rapidement. Mais j'ai été malade pendant une semaine. Quand je suis revenu, j'ai été ignoré à chaque fois. Pas de bonjour ni rien. ** grossiers et pas authentiques. Ils ont même accueilli chaleureusement les autres clients autour de moi. Et moi, j'étais invisible."],
        "upperSignalType": null,
        "lowerSignalType": "weakness",
        "i": 34
    }, {
        "index": 36,
        "name": "Les baristas se souviennent de leurs clients, comme dans un café de quartier / ne se souviennent pas de moi.",
        "shortName": "Les baristas se souviennent / ne se souviennent pas de leurs clients.",
        "stage": "INTERACTIONS AVEC LE PERSONNEL",
        "occurence": 2,
        "positiveIntensity": 293,
        "negativeIntensity": -58,
        "average": 21,
        "positiveVerbatim": ["Les baristas ici sont parmi les meilleurs que j'aie vus. Tôt le matin, ils voient leurs clients arriver au loin et commencent à préparer leur boisson préférée avant même qu'ils ne poussent la porte.", "Mon Starbucks m'a manqué pendant une semaine, alors que j'étais hospitalisé pour une (lègère) attaque. En y retournant, le Manager m'a offert une boisson en me disant combien il était soulagé de me revoir, et plusieurs de ses super collaborateurs m'ont souhaité un bon rétablissement. C'est peut-être une grande entreprise, mais il m'ont traité comme l'aurait fait la petite librairie du coin, qui serait tenue par un ami à moi. Exceptionnel !", "J'adore Ricardo. Il m'appelle par mon nom. Il est agréable quand il me voit. Je viens tellement souvent qu'il a mémorisé ma commande. C'est comme ça que devrait être le service aux clients. Si seulement il pouvait donner quelques cours à d'autres !!", "Le personnel était vraiment sympa, et l'endroit ressemblait à un petit café de quartier, pas un Starbucks corporate (les employés connaissaient les clients fidèles et ont plaisanté toute la soirée avec eux). ", "J'ADORE. Je viens ici TOUS LES JOURS. 👏 Tous ceux qui travaillent ici sont tellement sympas, ils connaissent mon prénom ! Et ils connaissent toujours ma commande habituelle, même si je change de temps en temps. "],
        "negativeVerbatim": [],
        "upperSignalType": "goodPractice",
        "lowerSignalType": null,
        "i": 35
    }, {
        "index": 37,
        "name": "Les baristas sont professionnels / ont besoin d'une meilleure formation.",
        "shortName": "Les baristas sont professionnels / ont besoin d'une formation.",
        "stage": "INTERACTIONS AVEC LE PERSONNEL",
        "occurence": 5,
        "positiveIntensity": 172,
        "negativeIntensity": -134,
        "average": 19,
        "positiveVerbatim": [],
        "negativeVerbatim": [],
        "upperSignalType": " ",
        "lowerSignalType": null,
        "i": 36
    }, {
        "index": 38,
        "name": "Ma commande est toujours conforme / il y a eu une erreur.",
        "shortName": "Ma commande est toujours conforme / il y a eu une erreur.",
        "stage": "INTERACTIONS AVEC LE PERSONNEL",
        "occurence": 3.3,
        "positiveIntensity": 160,
        "negativeIntensity": -154,
        "average": -96,
        "positiveVerbatim": [],
        "negativeVerbatim": ["Je ne suis pas un client difficile. Je commande à partir du menu. Les deux dernières fois que je suis allé dans mon SB local, ma commande était incorrecte. La première fois, j'étais au Drive et je ne m'en suis pas rendu compte avant d'être déjà loin, trop tard pour revenir en arrière. OK, des erreurs peuvent arriver. J'y suis retourné quelques jours plus tard et j'ai décidé de commander à l'intérieur, pour pouvoir vérifier que ma commande était correcte. Les gens qui y travaillent ne sont pas particulièrement agréables, mais je suis là pour le café. Quand ma commande était prête, il y avait à nouveau une erreur. J'ai essayé de le dire à quelqu'un mais j'ai été ignoré de manière flagrante."],
        "upperSignalType": null,
        "lowerSignalType": "weakness",
        "i": 37
    }, {
        "index": 39,
        "name": "Les baristas préparent ma boisson exactement comme je l'aime / elle n'est pas comme je l'aime.",
        "shortName": "Ma boisson est / n'est pas préparée exactement comme je l'aime.",
        "stage": "INTERACTIONS AVEC LE PERSONNEL",
        "occurence": 1.2,
        "positiveIntensity": 268,
        "negativeIntensity": -151,
        "average": 29,
        "positiveVerbatim": ["Le café était exactement comme je l'aime et même meilleur que ce à quoi je m'attendais. ", "J'adore Starbuckssssss, ils font toujours mon café comme je le souhaite. ", "L'autre truc cool, c'est qu'il n'ont jamais raté mon Vanilla Soy Chai Tea Latte. Ils le font toujours parfaitement. Ils ont totalement établi la norme pour cette boisson."],
        "negativeVerbatim": [],
        "upperSignalType": "goodPractice",
        "lowerSignalType": null,
        "i": 38
    }, {
        "index": 40,
        "name": "Je suis victime ou j'ai vu des clients victimes de discrimination.",
        "shortName": "Je suis victime ou j'ai vu des clients victimes de discrimination.",
        "stage": "INTERACTIONS AVEC LE PERSONNEL",
        "occurence": 0.6,
        "positiveIntensity": 0,
        "negativeIntensity": -186,
        "average": -140,
        "positiveVerbatim": [],
        "negativeVerbatim": ["Ça a été la pire expérience de service de toute ma vie. Y a-t-il une discrimination envers ceux qui ont du mal à parler Anglais comme moi, et une haine vis-à-vis des Asiatiques ?", "Discrimination envers les clients sud-asiatiques par les employés noirs. Pour être précis, je suis en première position dans la file, personne ne me demande si je veux commander, même quand j'ai la main levée pour demander de l'aide.", "Mon mari handicapé a des lésions cérébrales et des handicaps physiques dus à un accident de voiture. Il se trouve aussi être américano-mexicain. Ni l'un ni l'autre ne sont acceptables, semble-t-il, aux gens bien de chez Starbucks à Fresno, en Californie. (…) Nous nous sommes assis dehors à essayer de décider quoi commander quand un homme blanc à la tête rasée et aux yeux bleus sort et nous accuse de voler leur mobilier, dont aucune pièce ne manquait, et nous dit que si nous ne partons pas immédiatement, il appellera la police. (...) J'aimerais vraiment être contacté par un avocat disposé à défendre notre cas en tant que victimes de discrimination et d'humiliation."],
        "upperSignalType": null,
        "lowerSignalType": "weakness",
        "i": 39
    }, {
        "index": 41,
        "name": "Le manager est excellent / n'est pas au niveau.",
        "shortName": "Le manager est excellent / n'est pas au niveau.",
        "stage": "INTERACTIONS AVEC LE PERSONNEL",
        "occurence": 4.2,
        "positiveIntensity": 129,
        "negativeIntensity": -109,
        "average": -29,
        "positiveVerbatim": [],
        "negativeVerbatim": [],
        "upperSignalType": " ",
        "lowerSignalType": null,
        "i": 40
    }, {
        "index": 42,
        "name": "Je n'obtiens aucune excuse pour l'erreur commise.",
        "shortName": "Je n'obtiens aucune excuse pour l'erreur commise.",
        "stage": "INTERACTIONS AVEC LE PERSONNEL",
        "occurence": 0.9,
        "positiveIntensity": 0,
        "negativeIntensity": -127,
        "average": -86,
        "positiveVerbatim": [],
        "negativeVerbatim": [],
        "upperSignalType": " ",
        "lowerSignalType": null,
        "i": 41
    }, {
        "index": 43,
        "name": "Ma boisson est délicieuse / décevante.",
        "shortName": "Ma boisson est délicieuse / décevante.",
        "stage": "DÉGUSTATION",
        "occurence": 27,
        "positiveIntensity": 225,
        "negativeIntensity": -122,
        "average": 94,
        "positiveVerbatim": ["Fantastique, énorme et j'adore. La chose la plus délicieuse que j'aie goûtée parmi tous les cafés. C'est le meilleur. Merci d'avoir rendu ça si agréable.", "La Caramel frap avec extra drizzle est ma seule raison de vivre.", "J'aime quand ma boisson préférée revient en période de Noël, Salted Caramel Latte… délicieux ! ", "OH MON DIEU… Je viens d'essayer le Iced Dark Chocolate Mocha. C'est une boisson Starbucks Reserve. C'est tellement bon ! Si vous aimez le chocolat noir, c'est comme si vous buviez une barre chocolatée.\n"],
        "negativeVerbatim": [],
        "upperSignalType": "strength",
        "lowerSignalType": null,
        "i": 42
    }, {
        "index": 44,
        "name": "Il y a une grande variété au menu / le menu du déjeuner manque de choix.",
        "shortName": "Il y a une grande variété au menu / le menu déjeuner manque de choix.",
        "stage": "DÉGUSTATION",
        "occurence": 2.3,
        "positiveIntensity": 251,
        "negativeIntensity": -85,
        "average": 227,
        "positiveVerbatim": ["J'adore la variété des cafés et j'essaye toujours les nouveautés ! Et bien sûr il faut que j'essaye une petite douceur à déguster, à moins que je n'aie besoin de m'asseoir pour utiliser le wi-fi. Dans ce cas, je prendrai un sandwich en plus ! ", "Ils ajoutent toujours les dernières nouveautés au menu. Il ont un super choix de snacks frais et délicieuses pâtisseries.", "Ils ont la machine Clover ici et j'adore ! Cette machine est extraordinaire. Votre café est fait à la demande et il y a une très grande variété de styles de cafés."],
        "negativeVerbatim": [],
        "upperSignalType": "goodPractice",
        "lowerSignalType": null,
        "i": 43
    }, {
        "index": 45,
        "name": "C'est cher mais cela les vaut / compte-tenu du prix, j'attends mieux.",
        "shortName": "C'est cher mais cela les vaut / compte-tenu du prix, j'attends mieux.",
        "stage": "DÉGUSTATION",
        "occurence": 6.4,
        "positiveIntensity": 149,
        "negativeIntensity": -88,
        "average": -44,
        "positiveVerbatim": ["Je suis fan absolu de leur café et de leur service ! On est servi rapidement et le service est excellent ! Je n'ai aucun problème à payer le prix pour ce café. Jamais !", "C'est l'incarnation de ce qu'un bon service au client doit être - des gens de tous les horizons qui sont prêts à attendre longtemps, à payer le prix fort pour une tasse de café, sans se plaindre. En partie, je pense que cela est probablement dû au fait que le service au client, accueillant et excellent, est une chose rare de nos jours. Beau travail, Starbucks !", "Je suis un drogué de Starbucks ! Service absolument excellent à chaque endroit que je l''ai fréquenté. Cher, mais vous en avez pour votre argent. Félicitations à M. Schultz pour son brio en continu. "],
        "negativeVerbatim": [],
        "upperSignalType": " ",
        "lowerSignalType": null,
        "i": 44
    }, {
        "index": 46,
        "name": "La qualité est toujours excellente / se détériore.",
        "shortName": "La qualité est toujours excellente / se détériore.",
        "stage": "DÉGUSTATION",
        "occurence": 1.3,
        "positiveIntensity": 77,
        "negativeIntensity": -119,
        "average": 2,
        "positiveVerbatim": [],
        "negativeVerbatim": ["J'ai été tellement déçu l'année dernière par Starbucks. Le café n’est jamais constant, son goût est soit brûlé, soit on demande un supplément soja et il devient froid parce qu’on en met trop, ou bien la boisson est totalement ratée.", "Starbucks n'est plus un café !! Leur objectif est maintenant de vendre des boissons sucrées et caloriques pour 5 $. Il y a plus de 35 ans, le fondateur de Starbucks est entré dans son premier café, dans le but de faire la meilleure torréfaction et de servir le meilleur café. Ces fondations ont disparu depuis longtemps."],
        "upperSignalType": " ",
        "lowerSignalType": null,
        "i": 45
    }, {
        "index": 47,
        "name": "Les gobelets fuient.",
        "shortName": "Les gobelets fuient.",
        "stage": "DÉGUSTATION",
        "occurence": 0.5,
        "positiveIntensity": 0,
        "negativeIntensity": -116,
        "average": -85,
        "positiveVerbatim": [],
        "negativeVerbatim": [],
        "upperSignalType": " ",
        "lowerSignalType": null,
        "i": 46
    }, {
        "index": 48,
        "name": "J'adore ce Starbucks Reserve (variétés de café et design).",
        "shortName": "J'adore ce Starbucks Reserve (variétés de café et design).",
        "stage": "DÉGUSTATION",
        "occurence": 2.5,
        "positiveIntensity": 212,
        "negativeIntensity": 0,
        "average": 180,
        "positiveVerbatim": [],
        "negativeVerbatim": [],
        "upperSignalType": " ",
        "lowerSignalType": null,
        "i": 47
    }, {
        "index": 49,
        "name": "Starbucks propose des alternatives 'santé' / il n'y a pas assez d'offres 'santé', ou elles engendrent un surcoût.",
        "shortName": "Starbucks propose des alternatives 'santé' / pas assez ou trop chères.",
        "stage": "DÉGUSTATION",
        "occurence": 1.3,
        "positiveIntensity": 308,
        "negativeIntensity": -141,
        "average": 11,
        "positiveVerbatim": ["Beaucoup de choix bio, de choix adaptés aux vegans et même aux enfants ! ", "Non seulement Starbucks a une grande variété de cafés mais il propose le choix de nourriture le plus savoureux et sain. "],
        "negativeVerbatim": [],
        "upperSignalType": "goodPractice",
        "lowerSignalType": null,
        "i": 48
    }, {
        "index": 50,
        "name": "Les baristas font des tasses généreuses / ma tasse n'est pas remplie.",
        "shortName": "Les baristas font des tasses généreuses / ma tasse n'est pas remplie.",
        "stage": "DÉGUSTATION",
        "occurence": 0.4,
        "positiveIntensity": 65,
        "negativeIntensity": -253,
        "average": 14,
        "positiveVerbatim": [],
        "negativeVerbatim": ["Au cours des dernières années, j'ai remarqué plusieurs choses. Tout d’abord, les shots d’espresso ne sont plus pleins. Deuxièmement, les tasses ne sont plus remplies.", "Lorsque je commande un Venti Skinny Vanilla Latte, il n’est jamais plein - et avec tellement de mousse. Même quand je précise sans mousse. Quand je récupère le café, il y a toujours au moins 2,5 cm de mousse voire plus.", "Quand on commande un Grande ou autre, on attend un Grande. Ne me dites pas que c'est pour ajouter de la crème fouettée ou du lait, aucun de nous n'en a pris. C'est extrêmement décevant de payer plus de 5 $ pour un café, quand on n'obtient pas la quantité attendue.", "Depuis quelques semaines, je commence à voir mon Espresso Quad devenir en taille la moitié de ce qu'il était. Lorsque j'ai posé la question, le responsable du café m'a dit que Starbucks modifiait la quantité d'eau par shot d'espresso. Maintenant, pour le même prix, j'ai moins d'espresso."],
        "upperSignalType": null,
        "lowerSignalType": "weakness",
        "i": 49
    }, {
        "index": 51,
        "name": "La nourriture (snacks, pâtisserie…) est bonne / décevante.",
        "shortName": "La nourriture (snacks, pâtisserie…) est bonne / décevante.",
        "stage": "DÉGUSTATION",
        "occurence": 8.7,
        "positiveIntensity": 157,
        "negativeIntensity": -106,
        "average": 20,
        "positiveVerbatim": [],
        "negativeVerbatim": [],
        "upperSignalType": " ",
        "lowerSignalType": null,
        "i": 50
    }, {
        "index": 52,
        "name": "J'ai des allergies et les baristas n'ont jamais fait d'erreur sur mes commandes / j'ai eu des problèmes avec mes allergies.",
        "shortName": "Pas de problèmes avec mes allergies / j'ai eu des problèmes.",
        "stage": "DÉGUSTATION",
        "occurence": 0.7,
        "positiveIntensity": 10,
        "negativeIntensity": -90,
        "average": -63,
        "positiveVerbatim": [],
        "negativeVerbatim": [],
        "upperSignalType": " ",
        "lowerSignalType": null,
        "i": 51
    }, {
        "index": 53,
        "name": "Le Service Client est efficace / n'est pas au niveau.",
        "shortName": "Le Service Client est efficace / n'est pas au niveau.",
        "stage": "SERVICE CLIENT",
        "occurence": 11,
        "positiveIntensity": 127,
        "negativeIntensity": -78,
        "average": -47,
        "positiveVerbatim": ["Ils font toujours en sorte que votre prochaine expérience se passe mieux lorsque vous appelez la hotline du Service Client et que vous les informez de ce qui ne va pas. ", "J'ai eu des problèmes, avec une erreur de caisse dans un café Starbucks mais les conseillers du Service Client par email sont toujours extrêmement efficaces et font tout pour aider. "],
        "negativeVerbatim": ["Chaque Starbucks peut créer ses propres règles, différentes des politiques corporate, et le siège ne s'en préoccupe même pas. ", "J'ai réalisé que les employés de Starbucks n'étaient pas formés aux problèmes techniques et au téléphone, ils disent aux clients tout ce qu'ils peuvent pour s'en débarrasser."],
        "upperSignalType": " ",
        "lowerSignalType": null,
        "i": 52
    }, {
        "index": 54,
        "name": "Le service via la hotline est efficace / l'expérience est pénible.",
        "shortName": "Le service via la hotline est efficace / l'expérience est pénible.",
        "stage": "SERVICE CLIENT",
        "occurence": 7.9,
        "positiveIntensity": 194,
        "negativeIntensity": -104,
        "average": -47,
        "positiveVerbatim": ["Je ne savais pas très bien qui appeler, alors j'ai fait le numéro que j'ai trouvé sur le site web. Le conseiller qui a répondu était tellement efficace et rapide pour résoudre mon problème ! Très agréable aussi. Super expérience. "],
        "negativeVerbatim": ["Je suis énervé, frustré et déçu. Toutes les personnes à qui j'ai parlé semblaient être dans un endroit bruyant et distraites, aucune d'entre elles ne semblait vouloir m'aider. Je suis déçu par Starbucks pour cette expérience. Starbucks, vous avez à l'évidence besoin d’une meilleure formation au service client !", "J'ai appelé le numéro de téléphone sur l'e-mail et je suis passé par leur horrible système vocal qui demande environ 5 minutes de navigation. Après avoir localisé le bon département, j’ai été mis en attente pendant environ 5 minutes, juste pour m'entendre dire que j’étais dans le mauvais département. J'ai ensuite été mis en attente pendant environ 15 minutes, puis j'ai parlé à une 'superviseur' qui m'a alors répété qu'elle ne pouvait pas m'aider et qu'elle essaierait de me transférer au bon service. Sa « tentative » a été un échec, car tout ce qu'elle a réussi à faire, ça a été de me transférer à l'aveugle dans leur file d'attente automatisée, puis de basculer vers un autre processus automatisé de vérification de mes coordonnées, puis j'ai été mis en attente pendant environ 40 minutes.", "Lorsqu'on appelle le Service Client de Starbucks, on nous demande toutes sortes d'informations pour en arriver à la confirmation que la réclamation concerne bien un de leurs produits."],
        "upperSignalType": "priority",
        "lowerSignalType": null,
        "i": 53
    }, {
        "index": 55,
        "name": "La résolution est rapide et facile / mon problème n'est pas résolu.",
        "shortName": "La résolution est rapide et facile / mon problème n'est pas résolu.",
        "stage": "SERVICE CLIENT",
        "occurence": 2.6,
        "positiveIntensity": 182,
        "negativeIntensity": -98,
        "average": -62,
        "positiveVerbatim": [],
        "negativeVerbatim": [],
        "upperSignalType": " ",
        "lowerSignalType": null,
        "i": 54
    }, {
        "index": 56,
        "name": "On ne fait pas confiance à ma version des faits.",
        "shortName": "On ne fait pas confiance à ma version des faits.",
        "stage": "SERVICE CLIENT",
        "occurence": 0.4,
        "positiveIntensity": 0,
        "negativeIntensity": -130,
        "average": -101,
        "positiveVerbatim": [],
        "negativeVerbatim": [],
        "upperSignalType": " ",
        "lowerSignalType": null,
        "i": 55
    }, {
        "index": 57,
        "name": "Cela demande trop d'efforts de traiter avec le Service Client.",
        "shortName": "Cela demande trop d'efforts de traiter avec le Service Client.",
        "stage": "SERVICE CLIENT",
        "occurence": 0.9,
        "positiveIntensity": 0,
        "negativeIntensity": -263,
        "average": -149,
        "positiveVerbatim": [],
        "negativeVerbatim": ["C'est sans aucun doute la pire équipe de Service Client du pays : ils sont formés pour répéter : \" Je suis désolé mais un responsable de district vous recontactera \". Les employés sont impolis, n'y connaissent rien et manquent de professionnalisme. Si vous demandez à parler à quelqu'un de plus haut placé, il rira. Oh, et bien sûr la meilleure : le responsable de district ne vous appellera jamais. C'est tout simplement un cycle d'essorage pour vous faire abandonner. L'ensemble de ce programme d'usure signé Starbucks est conçu pour décourager les clients qui se plaignent.", "Faut-il obliger un client à appeler trois fois pour demander à parler à un responsable, tout ça pour être encore ignoré ?", "Je suis tellement épuisé de traiter avec cette entreprise que je pourrais ne jamais y retourner. Je vais faire un effort supplémentaire et appeler le numéro qu'ils m'ont fourni ! Je doute que j'obtienne une réponse satisfaisante."],
        "upperSignalType": null,
        "lowerSignalType": "weakness",
        "i": 56
    }, {
        "index": 58,
        "name": "Les clients fidèles sont choyés / la fidélité n'a pas de valeur pour Starbucks.",
        "shortName": "Les clients fidèles sont choyés / la fidélité n'a pas de valeur.",
        "stage": "RELATION CLIENT",
        "occurence": 5.6,
        "positiveIntensity": 123,
        "negativeIntensity": -90,
        "average": 13,
        "positiveVerbatim": [],
        "negativeVerbatim": [],
        "upperSignalType": " ",
        "lowerSignalType": null,
        "i": 57
    }, {
        "index": 59,
        "name": "J'aime le programme de fidélité de Starbucks / le nouveau programme est un scandale.",
        "shortName": "J'aime le programme de fidélité / le nouveau est un scandale.",
        "stage": "RELATION CLIENT",
        "occurence": 1.9,
        "positiveIntensity": 121,
        "negativeIntensity": -139,
        "average": -45,
        "positiveVerbatim": [],
        "negativeVerbatim": ["Ce sont des raisons suffisantes pour aller voir ailleurs. Sans parler du changement de programme de fidélité, qui oblige à dépenser une sacrée somme pour obtenir une boisson gratuite. Je pense vraiment que la société nous prend pour des imbéciles !", "Starbucks a commis une \"énorme\" erreur avec son changement de politique en avril 2016. Les clients, et moi compris, ne supportent pas ce changement. De qui se moquent-ils ! Les concurrents se frottent les mains… Ils vont récupérer plein de clients Starbucks. Avec ce programme scandaleux, Starbucks démontre qu'ils ne se soucient pas de leurs clients. Soyons Américains et votons \" pas de changement ! \" Merci.", "Quand j'ai découvert aujourd'hui le nouveau programme de fidélité Starbucks, je n'arrivais pas à y croire. Je ne sais pas quelle personne du marketing est venue avec cette idée, mais il faut la licencier. Ils cherchent à attirer l'attention du public sur ce nouveau programme. Ça m'attriste. À un moment, j'ai vraiment pensé que Starbucks était une excellente entreprise qui se souciait de ses clients. Apparemment non."],
        "upperSignalType": " ",
        "lowerSignalType": null,
        "i": 58
    }, {
        "index": 60,
        "name": "J'apprécie le sentiment de communauté.",
        "shortName": "J'apprécie le sentiment de communauté.",
        "stage": "RELATION CLIENT",
        "occurence": 1.1,
        "positiveIntensity": 129,
        "negativeIntensity": 0,
        "average": 106,
        "positiveVerbatim": [],
        "negativeVerbatim": [],
        "upperSignalType": " ",
        "lowerSignalType": null,
        "i": 59
    }, {
        "index": 61,
        "name": "Globalement, la qualité de service est bonne / mauvaise.",
        "shortName": "Globalement, la qualité de service est bonne / mauvaise.",
        "stage": "RESSENTI & PERCEPTIONS",
        "occurence": 22.7,
        "positiveIntensity": 227,
        "negativeIntensity": -104,
        "average": 10,
        "positiveVerbatim": [],
        "negativeVerbatim": [],
        "upperSignalType": " ",
        "lowerSignalType": null,
        "i": 60
    }, {
        "index": 62,
        "name": "Starbucks se soucie de ses clients / ne s'en soucie pas.",
        "shortName": "Starbucks se soucie de ses clients / ne s'en soucie pas.",
        "stage": "RESSENTI & PERCEPTIONS",
        "occurence": 12.7,
        "positiveIntensity": 144,
        "negativeIntensity": -105,
        "average": 28,
        "positiveVerbatim": ["Starbucks fait un super boulot pour repérer ses clients fidèles, les connaître, connaître leurs commandes habituelles, les appeler par leur nom. Ils vous font sentir que vous êtes un client important ! ", "Starbucks peut sembler cher, mais ils font vraiment tout pour que le client se sente privilégié et apprécié.  ", "J'ai vécu une expérience aujourd'hui : tous les Starbucks de notre région ont subi une panne informatique depuis ce matin et ne pouvaient pas prendre de commandes. Le magasin distribuait gratuitement un petit café ou un thé à quiconque entrait dans le café. Nous sommes allés dans deux magasins en pensant qu'un seul pratiquait cela, et les deux proposaient la même chose. Cela montre qu'ils apprécient leurs clients. Pensez à la somme d’argent qu'ils perdent en ventes et en distribution de produits gratuits, et pourtant, ce qu'ils souhaitent, c'est que les clients soient dédommagés pour s’être arrêtés dans leur magasin. Aujourd'hui, ils ont fait de moi un client pour la vie ! "],
        "negativeVerbatim": ["Je me rends compte que c'est du business, mais ils ont toujours su enjoliver les choses avec leurs jolies tasses, leur décoration et leurs sourires chaleureux. Maintenant, c'est devenu ennuyeux et leur seul moteur est le consumérisme.", "Membre Gold pour tous ceux qui passent la porte et effectuent un achat en avril ? Wow, mais vous vous moquez carrément de moi ? Savez-vous combien d'argent un membre Gold moyen a dépensé pour atteindre ce niveau avec votre entreprise ? C'est effroyable que vous ne sachiez pas apprécier cette fidélité. Grâce à votre promotion, vous nous avez démontré à tous que la loyauté ne signifie pas plus pour vous que quelqu'un qui n'a jamais été client. C'est absolument honteux et j'espère que vos profits reflèteront le fait que vous vous aliénez votre clientèle fidèle. Starbucks a longtemps été un symbole d'excès, mais maintenant,  c'est un symbole d'arrogance et de mépris pour ses clients. Je suis impatient d'aider les cafés du coin et autres plus grands concurrents à aller de l'avant."],
        "upperSignalType": "priority",
        "lowerSignalType": null,
        "i": 61
    }, {
        "index": 63,
        "name": "Starbucks est au-dessus de ses concurrents / il y a des concurrents plus intéressants.",
        "shortName": "Starbucks est au-dessus / en-dessous de ses concurrents.",
        "stage": "RESSENTI & PERCEPTIONS",
        "occurence": 1.8,
        "positiveIntensity": 174,
        "negativeIntensity": -97,
        "average": 45,
        "positiveVerbatim": [],
        "negativeVerbatim": [],
        "upperSignalType": " ",
        "lowerSignalType": null,
        "i": 62
    }, {
        "index": 64,
        "name": "Starbucks se soucie de l'environnement / devrait faire plus d'efforts sur le recyclage.",
        "shortName": "Starbucks se soucie de l'environnement / devrait faire plus d'efforts.",
        "stage": "RESSENTI & PERCEPTIONS",
        "occurence": 0.4,
        "positiveIntensity": 113,
        "negativeIntensity": -20,
        "average": 87,
        "positiveVerbatim": [],
        "negativeVerbatim": [],
        "upperSignalType": " ",
        "lowerSignalType": null,
        "i": 63
    }],
    "name": "Experience Client USA",
    "isKpamRH": false,
    "isComparative": false,
    "pdfDocumentPath": "/document/5/5c1be27b-5e6a-4f58-89bb-ff8a4e435b8e",
    "reportDocumentPath": null,
    "fichiers": true,
    "customerId": 2,
    "hasPdfDocument": true,
    "hasReportDocument": false
}

const fakeUS = {
    "id": 7,
    "touchpoints": [
        {
            "index": 1,
            "name": "The location and neighbourhood are great.",
            "shortName": "The location and neighbourhood are great.",
            "stage": "ACCESS TO THE STORE",
            "occurence": 4.6,
            "positiveIntensity": 195,
            "negativeIntensity": 0,
            "average": 169,
            "positiveVerbatim": [
                "Location location! Wow right across the street from those gorgeous lions. ",
                "Great view of Michigan Ave. Close to the park. Staff is friendly!",
                "Great location great vibes... employees are doing there job!"
            ],
            "negativeVerbatim": [],
            "upperSignalType": " ",
            "lowerSignalType": null
        },
        {
            "index": 2,
            "name": "The store is close to my place / my nearest Starbucks is far away.",
            "shortName": "The store is close to my place / my nearest Starbucks is far away.",
            "stage": "ACCESS TO THE STORE",
            "occurence": 1.5,
            "positiveIntensity": 129,
            "negativeIntensity": -121,
            "average": 65,
            "positiveVerbatim": [],
            "negativeVerbatim": [],
            "upperSignalType": " ",
            "lowerSignalType": null
        },
        {
            "index": 3,
            "name": "Parking is easy / the parking area is not convenient.",
            "shortName": "Parking is easy / the parking area is not convenient.",
            "stage": "ACCESS TO THE STORE",
            "occurence": 4.2,
            "positiveIntensity": 168,
            "negativeIntensity": -92,
            "average": -8,
            "positiveVerbatim": [
                "It's a pretty cool bucky's and it has great parking. It sits inside of a shopping center so there is ample parking.  ",
                "Perfect meeting place. Next to parking!",
                "They also have free parking which is unheard of for the area they're in."
            ],
            "negativeVerbatim": [],
            "upperSignalType": " ",
            "lowerSignalType": null
        },
        {
            "index": 4,
            "name": "I enjoy the late hours.",
            "shortName": "I enjoy the late hours.",
            "stage": "ACCESS TO THE STORE",
            "occurence": 4.5,
            "positiveIntensity": 199,
            "negativeIntensity": 0,
            "average": 133,
            "positiveVerbatim": [],
            "negativeVerbatim": [],
            "upperSignalType": " ",
            "lowerSignalType": null
        },
        {
            "index": 5,
            "name": "As a disabled person, I feel / I do not feel welcome.",
            "shortName": "As a disabled person, I feel / I do not feel welcome.",
            "stage": "ACCESS TO THE STORE",
            "occurence": 0.5,
            "positiveIntensity": 53,
            "negativeIntensity": -244,
            "average": -93,
            "positiveVerbatim": [],
            "negativeVerbatim": [
                "According to the Americans with Disabilities Act, I am allowed to bring my service animal anywhere that anyone can go. Thus meaning that I can bring my service dog into a Starbucks here in Sacramento, California. I was told to take my service animal outside of this store and tie him up on the bicycle rack that was located on the patio next to parking spaces for vehicles. that means that technically speaking I would have a lawsuit against Starbucks because of my service animal that has his vest, dog tags, and his paperwork. I am sick and tired of being told that I cannot take my service dog where I need him to go with me for my PTSD, TBI, and SDD. This is discrimination !!"
            ],
            "upperSignalType": null,
            "lowerSignalType": "weakness"
        },
        {
            "index": 6,
            "name": "I love this particular Starbucks / this particular Starbucks is disappointing.",
            "shortName": "I love this particular Starbucks / this particular Starbucks is disappointing.",
            "stage": "STORE ATMOSPHERE",
            "occurence": 35.4,
            "positiveIntensity": 178,
            "negativeIntensity": -147,
            "average": 30,
            "positiveVerbatim": [],
            "negativeVerbatim": [],
            "upperSignalType": " ",
            "lowerSignalType": null
        },
        {
            "index": 7,
            "name": "The atmosphere is great / unpleasant.",
            "shortName": "The atmosphere is great / unpleasant.",
            "stage": "STORE ATMOSPHERE",
            "occurence": 7.9,
            "positiveIntensity": 209,
            "negativeIntensity": -219,
            "average": 169,
            "positiveVerbatim": [
                "There is something in how they set up their tables, chairs, sofas, etc that makes the ambience great. ",
                "My absolute favorite ITP Starbucks. Such a happy vibes and amazing coffee. 🤙🏼☕️.",
                "Cute, and very busy Starbucks directly across the street from the Art Institute. Fun atmosphere, and really has that Chicago feel to it.",
                "How does one get emotionally attached to a Starbucks? If that Starbucks used to be your friendly neighborhood bowling alley. This one was. It's your standard Starbucks with a twist. A bit larger than your typical joint, but there are very important architectural twists on the traditional layout that give appropriate respect to the original structure."
            ],
            "negativeVerbatim": [],
            "upperSignalType": "strength",
            "lowerSignalType": "weakness"
        },
        {
            "index": 8,
            "name": "The place is beautiful / I don't like the decor.",
            "shortName": "The place is beautiful / I don't like the decor.",
            "stage": "STORE ATMOSPHERE",
            "occurence": 2.6,
            "positiveIntensity": 224,
            "negativeIntensity": -96,
            "average": 51,
            "positiveVerbatim": [
                "I really like this Starbucks. Big tables, plenty of seating areas and nice staff ! Also, the golden hand painted typography mural on the wall is so beautiful!",
                "This is the best Starbucks in Atlanta. They're quick, polite, and friendly. Also, the building itself is beautiful.",
                "This is a Starbucks Reserve and likely the most cool looking, swanky Starbucks in Atlanta. You can order fancy coffee here pour over , chemex , french press , and other things not typically offered at Sbux. Copper hanging lamps, a cool world map, outdoor seating, bar seating, it's just atypical for Starbucks and well worth the trip.",
                "Beautifully decorated, awesome view. This is the best Starbucks I've ever been to. "
            ],
            "negativeVerbatim": [],
            "upperSignalType": "goodPractice",
            "lowerSignalType": null
        },
        {
            "index": 9,
            "name": "I love the smell of coffee when I open the door.",
            "shortName": "I love the smell of coffee when I open the door.",
            "stage": "STORE ATMOSPHERE",
            "occurence": 0.4,
            "positiveIntensity": 212,
            "negativeIntensity": 0,
            "average": 173,
            "positiveVerbatim": [
                "When you open the door and the smell from the java of the day hits you... you immediately realize this is a unique experience. At every turn your senses are romanced and seduced by inviting textures, the sights, the taste and the luxurious smells. This is place where coffee beverages are carefully crafted... ",
                "The smell and ambiance of the store is really good. It's very soothing, energizing, and delicious."
            ],
            "negativeVerbatim": [],
            "upperSignalType": "goodPractice",
            "lowerSignalType": null
        },
        {
            "index": 10,
            "name": "There's a lot of space and seating available / I cannot find any place to sit.",
            "shortName": "There's a lot of space and seating available / I cannot find any place to sit.",
            "stage": "STORE ATMOSPHERE",
            "occurence": 6.7,
            "positiveIntensity": 309,
            "negativeIntensity": -64,
            "average": 255,
            "positiveVerbatim": [
                "One of the biggest Starbucks I've seen! Plenty of places to meet and talk – tables, benches, barstools and armchairs.",
                "It was the nicest I seen. Cleaner than many other locations and plenty of study room compared to the closet spaces they tend to be in.",
                "Love the Starbucks by NYU. It's huge and has great window seating. "
            ],
            "negativeVerbatim": [],
            "upperSignalType": "strength",
            "lowerSignalType": null
        },
        {
            "index": 11,
            "name": "There are different seating areas for different needs.",
            "shortName": "There are different seating areas for different needs.",
            "stage": "STORE ATMOSPHERE",
            "occurence": 1.7,
            "positiveIntensity": 160,
            "negativeIntensity": 0,
            "average": 137,
            "positiveVerbatim": [],
            "negativeVerbatim": [],
            "upperSignalType": " ",
            "lowerSignalType": null
        },
        {
            "index": 12,
            "name": "The store is cosy, comfortable / I cannot sit comfortably and quietly.",
            "shortName": "The store is cosy, comfortable / I cannot sit comfortably and quietly.",
            "stage": "STORE ATMOSPHERE",
            "occurence": 6.4,
            "positiveIntensity": 197,
            "negativeIntensity": -155,
            "average": 123,
            "positiveVerbatim": [
                "I'm a Starbucks junky. This one on California at the Laurel Heights Village is super crowded. Managed to snag a comfy leather chair to sip my latte. ",
                "They had lots of different table sizes and also big comfy chairs. The restrooms were immaculate."
            ],
            "negativeVerbatim": [
                "It is appalling that people who want to use the tables, order good meal of coffee and sandwich have no place to sit. Even the handicapped seats are occupied by the olympic-looking like students and the staff don't care.",
                "Biggest minus: people (often young and healthy) hog seats without consuming food. And there are too few senior friendly seats (chairs with backs that are a normal height so that your feet can touch the floor)."
            ],
            "upperSignalType": null,
            "lowerSignalType": "weakness"
        },
        {
            "index": 13,
            "name": "I can take a pause and truly relax / it's too busy to relax.                  ",
            "shortName": "I can take a pause and truly relax / it's too busy to relax.                  ",
            "stage": "STORE ATMOSPHERE",
            "occurence": 4.3,
            "positiveIntensity": 310,
            "negativeIntensity": -147,
            "average": 236,
            "positiveVerbatim": [
                "Perfect place to unplug.",
                "I love this place it helps me get away from every one. Its my private place.",
                "Good pit stop after shopping on Henderson."
            ],
            "negativeVerbatim": [],
            "upperSignalType": "goodPractice",
            "lowerSignalType": null
        },
        {
            "index": 14,
            "name": "It's clean / it's dirty, not maintained throughout the day.",
            "shortName": "It's clean / it's dirty, not maintained throughout the day.",
            "stage": "STORE ATMOSPHERE",
            "occurence": 7.6,
            "positiveIntensity": 236,
            "negativeIntensity": -122,
            "average": 9,
            "positiveVerbatim": [
                "Love the street view of Michigan Ave from here. Only good vibes especially with the cleanliness of the place.",
                "Clean place, great vibe.",
                "This one was very clean, well organized, sugar and dairy station had all variety of things."
            ],
            "negativeVerbatim": [],
            "upperSignalType": "goodPractice",
            "lowerSignalType": null
        },
        {
            "index": 15,
            "name": "The restrooms are nice and clean / dirty.",
            "shortName": "The restrooms are nice and clean / dirty.",
            "stage": "STORE ATMOSPHERE",
            "occurence": 2.5,
            "positiveIntensity": 222,
            "negativeIntensity": -149,
            "average": 39,
            "positiveVerbatim": [],
            "negativeVerbatim": [],
            "upperSignalType": "goodPractice",
            "lowerSignalType": null
        },
        {
            "index": 16,
            "name": "The wi-fi is fast / slow.",
            "shortName": "The wi-fi is fast / slow.",
            "stage": "STORE ATMOSPHERE",
            "occurence": 2.4,
            "positiveIntensity": 232,
            "negativeIntensity": -8,
            "average": 194,
            "positiveVerbatim": [
                "Awesome customer service, the wi-fi is fast and so is the service. Great experience like always.",
                "The atmosphere inside is nice and the staff was friendly. Internet working great. Oh yeah and Starbucks coffee."
            ],
            "negativeVerbatim": [],
            "upperSignalType": "goodPractice",
            "lowerSignalType": null
        },
        {
            "index": 17,
            "name": "There are plenty of power outlets.",
            "shortName": "There are plenty of power outlets.",
            "stage": "STORE ATMOSPHERE",
            "occurence": 1.8,
            "positiveIntensity": 216,
            "negativeIntensity": 0,
            "average": 147,
            "positiveVerbatim": [],
            "negativeVerbatim": [],
            "upperSignalType": " ",
            "lowerSignalType": null
        },
        {
            "index": 18,
            "name": "It's a great place to work or study / it's too busy to work.",
            "shortName": "It's a great place to work or study / it's too busy to work.",
            "stage": "STORE ATMOSPHERE",
            "occurence": 1.6,
            "positiveIntensity": 234,
            "negativeIntensity": -50,
            "average": 125,
            "positiveVerbatim": [
                "This Starbucks is huge and has a really cool chill atmosphere where you can have a catch up session with friends or get your work done with just you and your laptop. It feels really inviting.",
                "24 hour large Starbucks. Great place for late night coding.",
                "My number one spot to go after work to use the free WIFI and ample space to get a lot of work done. "
            ],
            "negativeVerbatim": [],
            "upperSignalType": "goodPractice",
            "lowerSignalType": null
        },
        {
            "index": 19,
            "name": "I feel safe / a customer makes me feel unsafe.",
            "shortName": "I feel safe / a customer makes me feel unsafe.",
            "stage": "STORE ATMOSPHERE",
            "occurence": 1.3,
            "positiveIntensity": 88,
            "negativeIntensity": -97,
            "average": -61,
            "positiveVerbatim": [],
            "negativeVerbatim": [],
            "upperSignalType": " ",
            "lowerSignalType": null
        },
        {
            "index": 20,
            "name": "I love the outdoor area.",
            "shortName": "I love the outdoor area.",
            "stage": "STORE ATMOSPHERE",
            "occurence": 1.8,
            "positiveIntensity": 232,
            "negativeIntensity": 0,
            "average": 157,
            "positiveVerbatim": [
                "The Starbucks location on the \"Trail\" is one of the best appearing. Huge room, comfortable tables and chairs, and a large outside deck with the proper screening for Arizona heat. ",
                "There are ample of windows, and great lighting. Outdoor tables and windows for great spring days outside to enjoy the neighborhood.",
                "I love the outdoor seating here. Best view."
            ],
            "negativeVerbatim": [],
            "upperSignalType": "goodPractice",
            "lowerSignalType": null
        },
        {
            "index": 21,
            "name": "I love the view from this Starbucks.",
            "shortName": "I love the view from this Starbucks.",
            "stage": "STORE ATMOSPHERE",
            "occurence": 1.3,
            "positiveIntensity": 276,
            "negativeIntensity": 0,
            "average": 257,
            "positiveVerbatim": [
                "Coffee with a view of Hard Rock Cafe, Bubba Gump Shrimp and the NYPD headquarters, who could ask for more? Lol.",
                "Went nearly every day for a cool drink. The location is amazing with table chairs parasols outside and a view of the park and ocean.",
                "Beautifully decorated, awesome view. This is the best Starbucks I've ever been to. ",
                "This Starbucks is a great place to stop for a while when on Lincoln Road. There is outdoor seating, so you can \"people watch\" while sipping on your drink. "
            ],
            "negativeVerbatim": [],
            "upperSignalType": "goodPractice",
            "lowerSignalType": null
        },
        {
            "index": 22,
            "name": "Other customers are pleasant / are a nuisance.",
            "shortName": "Other customers are pleasant / are a nuisance.",
            "stage": "STORE ATMOSPHERE",
            "occurence": 0.4,
            "positiveIntensity": 296,
            "negativeIntensity": -101,
            "average": 256,
            "positiveVerbatim": [
                "The customers, barristas, and people just trying to get work done are always upbeat, polite, and positive. It's such a pleasure to come here! Hands down the best 🌟 Starbucks in Miami. 🙌.",
                "In addition to the cool people that work there I would have to say that it has to be the locals like me that give it its special charm. We Crenshaw-nites are real chill people. Unlike the Magic Johnson Starbucks in La Dera this one isn't set up like a club that is crowded on Friday and Saturday nights. It's just filled with enough people to provide a pleasant buzz to go along with the whir of the espresso machines. I hope this Starbucks never closes down. It's my Cheers. It's my home! lol.",
                "Wonderful place for people watching, popular with young professionals, students, entrepreneurs, housewives, empty nesters and well to do locals. Plenty of singles looking to mingle here as well. Highly recommended.",
                "The environment is so professional. When I am here, get moco and read my email. This Starbucks gives me a sense of serenity."
            ],
            "negativeVerbatim": [],
            "upperSignalType": "goodPractice",
            "lowerSignalType": null
        },
        {
            "index": 23,
            "name": "Starbucks is too elitist.            ",
            "shortName": "Starbucks is too elitist.            ",
            "stage": "STORE ATMOSPHERE",
            "occurence": 0.4,
            "positiveIntensity": 0,
            "negativeIntensity": -148,
            "average": -107,
            "positiveVerbatim": [],
            "negativeVerbatim": [
                "The employees seem to have the same far left elitist attitude as the CEO and general direction of the company. Why anyone would spend $5 on coffee escapes me? For that $5 I can get a pound of coffee beans, store them in a vacuum container and grind fresh coffee every morning."
            ],
            "upperSignalType": " ",
            "lowerSignalType": null
        },
        {
            "index": 24,
            "name": "The service is fast and easy / is not smooth.",
            "shortName": "The service is fast and easy / is not smooth.",
            "stage": "IN-STORE BUYING                ",
            "occurence": 19.3,
            "positiveIntensity": 75,
            "negativeIntensity": -74,
            "average": -20,
            "positiveVerbatim": [
                "Fast service, even when they get \"Starbucks\" busy. ",
                "They're usually pretty busy, but they're fast and your order is ready before you know it! "
            ],
            "negativeVerbatim": [
                "I came in and ordered a tall caffe latte with soy. I waited for over 15 minutes and I had to leave without my drink. Very unhappy.",
                "My 16 year-old daughter went into the Starbucks inside the Kroger, Jefferson, GA. She was second in line, ordered and paid for her drink. Several people came in after her, ordered their drinks and left before she received her drink. "
            ],
            "upperSignalType": " ",
            "lowerSignalType": null,
            "i": 23
        },
        {
            "index": 25,
            "name": "Ordering is easy / my order doesn't go smoothly.",
            "shortName": "Ordering is easy / my order doesn't go smoothly.",
            "stage": "IN-STORE BUYING                ",
            "occurence": 10.8,
            "positiveIntensity": 89,
            "negativeIntensity": -81,
            "average": -45,
            "positiveVerbatim": [],
            "negativeVerbatim": [],
            "upperSignalType": " ",
            "lowerSignalType": null,
            "i": 24
        },
        {
            "index": 26,
            "name": "Although it's crowded, the lines move quickly / I have to wait far too long.",
            "shortName": "Although it's crowded, the lines move quickly / I have to wait far too long.",
            "stage": "IN-STORE BUYING                ",
            "occurence": 18.7,
            "positiveIntensity": 137,
            "negativeIntensity": -88,
            "average": -27,
            "positiveVerbatim": [
                "I was surprised. For starters the drink was made with perfect flavor of what I was expecting and made really quick considering the crowd that was in the store. ",
                "I like this place. The people who work there are amazing! With this crowd all day they are always nice & smiley. Coffee & food come fast. ",
                "They do a good job at keeping up with big crowds and have friendly staff."
            ],
            "negativeVerbatim": [
                "Very unmotivated staffs. If you walk into any Starbucks, you will encounter a variety of cool nerds with absolutely no awareness of the customers' time. ",
                "Go to this SB forever and recently there are new employees who are terrible. Just waited in line for 20 min only for them to say they ran out of iced coffee. It is 90 degrees outside, don't you think you should plan and make extra iced coffee? "
            ],
            "upperSignalType": "priority",
            "lowerSignalType": null,
            "i": 25
        },
        {
            "index": 27,
            "name": "The app is great to avoid the lines / in-store orders are treated more poorly than mobile orders.",
            "shortName": "The app is great to avoid the lines / in-store orders are treated more poorly than mobile orders.",
            "stage": "IN-STORE BUYING                ",
            "occurence": 4.5,
            "positiveIntensity": 98,
            "negativeIntensity": -189,
            "average": -49,
            "positiveVerbatim": [
                "My favorite Starbucks! Mobile ordering makes it so easy in the morning to get my coffee fix! "
            ],
            "negativeVerbatim": [
                "This is exactly what I feared would happen : people who can afford a smartphone jump every line and get serviced first. ",
                "Have you had the experience of going into a store and placing your order, then have your drink moved to the back of the line so that mobile orders get priority? Doesn't seem exactly customer friendly. I waited 20 min for my drink on a quiet day at a local Starbucks store. It seems like the employees should also take into consideration how long their walk in customer has been waiting... Very frustrating! Contemplating finding a more customer friendly coffee shop after being a loyal customer of Starbucks for years...."
            ],
            "upperSignalType": null,
            "lowerSignalType": "weakness",
            "i": 26
        },
        {
            "index": 28,
            "name": "They spelled my name wrong.",
            "shortName": "They spelled my name wrong.",
            "stage": "IN-STORE BUYING                ",
            "occurence": 0.4,
            "positiveIntensity": 0,
            "negativeIntensity": -88,
            "average": -13,
            "positiveVerbatim": [],
            "negativeVerbatim": [],
            "upperSignalType": " ",
            "lowerSignalType": null,
            "i": 27
        },
        {
            "index": 29,
            "name": "I get freebies / there are excessive additional charges.",
            "shortName": "I get freebies / there are excessive additional charges.",
            "stage": "IN-STORE BUYING                ",
            "occurence": 1.7,
            "positiveIntensity": 113,
            "negativeIntensity": -188,
            "average": -12,
            "positiveVerbatim": [],
            "negativeVerbatim": [
                "I ordered two ice teas and requested no water or syrup, but did request extra ice. The clerk rang the order up and then told me she would have to charge me an extra 75 cents for each drink because I had ask for NO water. A dollar fifty for NO water. I find this very hard to believe that the Base Exchange would tack on such a charge.",
                "I always go every morning and again most afternoons to order a grande Americano with extra cream and one Splenda. Typically, the barista will put about one inch of ½ and ½ in my drink to accommodate my extra cream request, which is perfect. This inch of cream amounts to about ¼ C of cream. On my visit the morning of August 4th, I was informed by the employee that they would be charging an additional .60 for the “extra cream”."
            ],
            "upperSignalType": null,
            "lowerSignalType": "weakness",
            "i": 28
        },
        {
            "index": 30,
            "name": "The cashier is friendly / the check-out goes wrong.",
            "shortName": "The cashier is friendly / the check-out goes wrong.",
            "stage": "IN-STORE BUYING                ",
            "occurence": 2,
            "positiveIntensity": 176,
            "negativeIntensity": -109,
            "average": -45,
            "positiveVerbatim": [],
            "negativeVerbatim": [],
            "upperSignalType": " ",
            "lowerSignalType": null,
            "i": 29
        },
        {
            "index": 31,
            "name": "The promotion or discount cannot be applied.",
            "shortName": "The promotion or discount cannot be applied.",
            "stage": "IN-STORE BUYING                ",
            "occurence": 1,
            "positiveIntensity": 0,
            "negativeIntensity": -97,
            "average": -50,
            "positiveVerbatim": [],
            "negativeVerbatim": [
                "Just tried to use a coupon that I got at the Starbucks in Havertown PA. 50% off a lunch item after 11 am (it's 2pm). They said that they don't honor the coupon. Yep they gave them out. But they don't accept them. What kind of way is this to treat customers ?"
            ],
            "upperSignalType": " ",
            "lowerSignalType": null,
            "i": 30
        },
        {
            "index": 32,
            "name": "I  always tip the baristas for their hard work. ",
            "shortName": "I  always tip the baristas for their hard work. ",
            "stage": "IN-STORE BUYING                ",
            "occurence": 0.4,
            "positiveIntensity": 98,
            "negativeIntensity": 0,
            "average": 60,
            "positiveVerbatim": [],
            "negativeVerbatim": [],
            "upperSignalType": " ",
            "lowerSignalType": null,
            "i": 31
        },
        {
            "index": 33,
            "name": "I had a great / frustrating interaction with a staff member.              ",
            "shortName": "I had a great / frustrating interaction with a staff member.              ",
            "stage": "THE STAFF",
            "occurence": 30,
            "positiveIntensity": 172,
            "negativeIntensity": -99,
            "average": 20,
            "positiveVerbatim": [
                "Your associate Lucy was extremely nice and knew just how I wanted my coffee. The store was clean, and everyone was friendly. Trust me I will be a regular customer at this location.",
                "I love this location, the staff are down to earth and their interaction with the customer are unforgettable... I see people come in here everyday and it seems to be the same people..The staff always remember their names and what they talked about the day or even a week before. Always a pleasure to come in here...",
                "There's a new guy Mario. He's quick and has great customer service. Keep smiling Mario. Your making people's day !",
                "Every Sunday morning I go into the Starbucks near our church and continue to be delighted with their service and coffee. Jameslyn has been tremendous, always knowing exactly how I like my coffee and asking how my week was. She and the others there have been super-friendly. "
            ],
            "negativeVerbatim": [
                "Alexis in the Starbucks is so rude every time I go in. She gives you the impression you are putting her out requesting a coffee beverage. Management should get rid of her. Awful experience. Never going back!",
                "I see employees that are too busy talking about what they did last night to pay attention to any customer…"
            ],
            "upperSignalType": "priority",
            "lowerSignalType": null
        },
        {
            "index": 34,
            "name": "Baristas are friendly / unfriendly.",
            "shortName": "Baristas are friendly / unfriendly.",
            "stage": "THE STAFF",
            "occurence": 23.1,
            "positiveIntensity": 240,
            "negativeIntensity": -113,
            "average": 13,
            "positiveVerbatim": [
                "Friendly service and the staff makes an effort to get to know you. ",
                "It's like going to a friend's house every weekend.",
                "This location is great! I'm a little biased in that \"Bee\" (I think she's a shift supervisor) always notices when I make healthy choices and comments on the weight I've been losing. Most of my close family and friends haven't even noticed!",
                "I appreciated that the people behind the counter seemed to have a relationship with the patrons, making it feel more like a community spot."
            ],
            "negativeVerbatim": [
                "More often than not, the window employee will hand me my drink and I’m the only one saying thank you. How is it that the only person saying thank you in this scenario is the customer? Should it not be the other way around? ",
                "When I go to put a tip in the jar, they have already turned their backs without a \" thank you \". Whether the store is busy or slow, customer service has taken a huge nose dive into zero service. ",
                "The barista was in a hurry, I received no hi and my friend and I noticed the girl was picking up the chairs and tables at 7:45pm. She said I could not sit because she was stacking the tables so I sat on the ledge of the sidewalk. She was not friendly and she seemed eager for us to leave when 8:25pm arrived. "
            ],
            "upperSignalType": "priority",
            "lowerSignalType": null
        },
        {
            "index": 35,
            "name": "I feel welcome / ignored.",
            "shortName": "I feel welcome / ignored.",
            "stage": "THE STAFF",
            "occurence": 6.4,
            "positiveIntensity": 68,
            "negativeIntensity": -163,
            "average": 46,
            "positiveVerbatim": [],
            "negativeVerbatim": [
                "There are 6, 7 employees working, the line is short and all employees are serving the drive-thru customers, totally ignoring us. Even when we speak up, they are rude and ignore us.",
                "There was a person in front of me who was served and had their coffee by a girl. She was talking to the customer and paid no notice of me. Another person came up behind me and also wanted a coffee, got sick of waiting and walked off. Who is this young lady and why is she still working here ? She was so rude.",
                "I went to the Starbucks in San Antonio on Bitters Road, and I sat and sat for my drink. There was no one else in line and they made drink after drink for the drive thru and while I waited and waited. I will never go back there where people inside are ignored.",
                "They used to greet me and be fast. But I was gone sick for a week. When I came back I was ignored every time. No hello or nothing. ** rude and fake. They even greeted customers around me. I was invisible."
            ],
            "upperSignalType": null,
            "lowerSignalType": "weakness"
        },
        {
            "index": 36,
            "name": "Baristas remember their customers, it has a local coffee shop feel / they don't remember me.",
            "shortName": "Baristas remember their customers, it has a local coffee shop feel / they don't remember me.",
            "stage": "THE STAFF",
            "occurence": 2,
            "positiveIntensity": 293,
            "negativeIntensity": -58,
            "average": 21,
            "positiveVerbatim": [
                "The baristas here are some of the best I have seen. At the early hours in the morning, they could see their regular customers approaching from the hill nearby, and they would get their drinks started for them - before they even entered the building.",
                "Missed going into my Starbucks locally for a week while in hospital with a stroke (mild). Upon going back in the Manager comped me a drink, said he was relieved to see me, and several of his (stellar) staff wished me well. Might be a big corporation - but they treat me like I get treated at the comic book shop owned by a good friend of mine. Outstanding!!",
                "I love Ricardo. He calls me by name. He is pleasant when he sees me. I come so much he has my order memorized. This is what customer service should be. If he could only teach the other ones !!!",
                "The staff were really nice, and the place felt like a local coffee shop, not a corporate Starbucks (the workers knew the regulars and would joke around all night with them).",
                "LOVE IT. Come here DAILY. 👏 Everyone that works here is so nice, they know me by first name! (…) And they always know my usual orders, even though I switch it up sometimes! "
            ],
            "negativeVerbatim": [],
            "upperSignalType": "goodPractice",
            "lowerSignalType": null
        },
        {
            "index": 37,
            "name": "Baristas are professional and knowledgeable / need better training.",
            "shortName": "Baristas are professional and knowledgeable / need better training.",
            "stage": "THE STAFF",
            "occurence": 5,
            "positiveIntensity": 172,
            "negativeIntensity": -134,
            "average": 19,
            "positiveVerbatim": [],
            "negativeVerbatim": [],
            "upperSignalType": " ",
            "lowerSignalType": null
        },
        {
            "index": 38,
            "name": "Baristas always get my order right / they got my order wrong.",
            "shortName": "Baristas always get my order right / they got my order wrong.",
            "stage": "THE STAFF",
            "occurence": 3.3,
            "positiveIntensity": 160,
            "negativeIntensity": -154,
            "average": -96,
            "positiveVerbatim": [],
            "negativeVerbatim": [
                "I am not a difficult customer. I order from the menu. The last two times I went to my local SB my order was incorrect. The first time I had gone to the drive through and didn't realize it until I was well on my way to where I was going and did not have the time to go back. OK, so mistakes happen. I went back a few days later and decided to go inside to ensure my order was correct. The people that work there are not particularly pleasant, but I'm there for coffee. When my order was ready it was wrong again. I tried to tell someone but was blatantly ignored. "
            ],
            "upperSignalType": null,
            "lowerSignalType": "weakness"
        },
        {
            "index": 39,
            "name": "Baristas make my drink exactly how I like it / my drink was not how I like it.",
            "shortName": "Baristas make my drink exactly how I like it / my drink was not how I like it.",
            "stage": "THE STAFF",
            "occurence": 1.2,
            "positiveIntensity": 268,
            "negativeIntensity": -151,
            "average": 29,
            "positiveVerbatim": [
                "The Coffee was exactly how I wanted it and tasted better than what I had hoped for. ",
                "Love Starbuckssssss they always make my coffee the way I want it.",
                "The other cool part is they NEVER mess up my Vanilla Soy Chai Tea Latte. They only make it great and better. They've totally set the standard for this drink of mine.  "
            ],
            "negativeVerbatim": [],
            "upperSignalType": "goodPractice",
            "lowerSignalType": null
        },
        {
            "index": 40,
            "name": "I suffered or saw customers suffering discrimination from a barista.",
            "shortName": "I suffered or saw customers suffering discrimination from a barista.",
            "stage": "THE STAFF",
            "occurence": 0.6,
            "positiveIntensity": 0,
            "negativeIntensity": -186,
            "average": -140,
            "positiveVerbatim": [],
            "negativeVerbatim": [
                "I had been the worse customer service in my whole life. Is there discrimination with whom is tough speaking English as me and hated Asian person.",
                "Discriminate South Asian customer by black workers. To be fair, I stood in front of the line no one say if I want to order, even though I have my hand raised to get help."
            ],
            "upperSignalType": null,
            "lowerSignalType": "weakness"
        },
        {
            "index": 41,
            "name": "The manager is great / not up to the task.",
            "shortName": "The manager is great / not up to the task.",
            "stage": "THE STAFF",
            "occurence": 4.2,
            "positiveIntensity": 129,
            "negativeIntensity": -109,
            "average": -29,
            "positiveVerbatim": [],
            "negativeVerbatim": [],
            "upperSignalType": " ",
            "lowerSignalType": null
        },
        {
            "index": 42,
            "name": "I didn't get apologies for the mistake.",
            "shortName": "I didn't get apologies for the mistake.",
            "stage": "THE STAFF",
            "occurence": 0.9,
            "positiveIntensity": 0,
            "negativeIntensity": -127,
            "average": -86,
            "positiveVerbatim": [],
            "negativeVerbatim": [],
            "upperSignalType": " ",
            "lowerSignalType": null
        },
        {
            "index": 43,
            "name": "My drink is delicious / disappointing.",
            "shortName": "My drink is delicious / disappointing.",
            "stage": "DRINKING & EATING",
            "occurence": 27,
            "positiveIntensity": 225,
            "negativeIntensity": -122,
            "average": 94,
            "positiveVerbatim": [
                "Fantastic, outrageous and love it. The most delicious thing I have tasted out of all coffees. This is the best one. Thank you for making it nice to enjoy.",
                "Caramel frap with extra drizzle is my only will to live.",
                "I like when they have my favorite drink during the holidays, salted caramel latte… delicious!.",
                "OH MY GOSH... Just tried the Iced Dark Chocolate Mocha. Its a Starbucks Reserve drink. Its so freaking good if you like dark chocolate its like drinking a Candy bar."
            ],
            "negativeVerbatim": [],
            "upperSignalType": "strength",
            "lowerSignalType": null
        },
        {
            "index": 44,
            "name": "They have a great variety on the menu / the lunch menu is too limited.",
            "shortName": "They have a great variety on the menu / the lunch menu is too limited.",
            "stage": "DRINKING & EATING",
            "occurence": 2.3,
            "positiveIntensity": 251,
            "negativeIntensity": -85,
            "average": 227,
            "positiveVerbatim": [
                "I love the variety of coffees and always try the newest flavors! And of course I have to try a little sweet treat, unless I have to sit down for some wi-fi, then I'll have a sandwich too! ",
                "Always adding to the menu the newest options. They have a great selection of fresh food and delicious baked good options.",
                "I love that they have the clover machine here. This machine is awesome. Your coffee is done to order and you can order a wide variety of styles of coffee."
            ],
            "negativeVerbatim": [],
            "upperSignalType": "goodPractice",
            "lowerSignalType": null
        },
        {
            "index": 45,
            "name": "It's worth the premium pricing / considering the pricing, I expect more.",
            "shortName": "It's worth the premium pricing / considering the pricing, I expect more.",
            "stage": "DRINKING & EATING",
            "occurence": 6.4,
            "positiveIntensity": 149,
            "negativeIntensity": -88,
            "average": -44,
            "positiveVerbatim": [
                "I absolutely love their coffee and their service! Prompt delivery and excellent service! I do not mind paying the money for this coffee ever!",
                "This is a testament to what good customer service can do - people of all walks in life that are willing to wait a sometimes long period of time, to pay a high price for a cup of java without complaint. In part, I believe that this is probably due to the fact that friendly, excellent customer service is such a rarity these days. Nice job, Starbucks!",
                "I'm a Starbucks junkie! Absolutely great customer service at each location I've visited. Expensive, but you get what you pay for. Kudos to Mr. Schultz for his continual brilliance."
            ],
            "negativeVerbatim": [],
            "upperSignalType": " ",
            "lowerSignalType": null
        },
        {
            "index": 46,
            "name": "The quality is consistently great / has deteriorated.",
            "shortName": "The quality is consistently great / has deteriorated.",
            "stage": "DRINKING & EATING",
            "occurence": 1.3,
            "positiveIntensity": 77,
            "negativeIntensity": -119,
            "average": 2,
            "positiveVerbatim": [],
            "negativeVerbatim": [
                "I have been so disappointed in the last year with Starbucks. Coffee is never consistent, taste is either burnt or you ask for extra soy and it's cold because they put too much, or they get the drink wrong completely.",
                "Starbucks is no longer a coffee shop !! Their focus now is to sell sweet and heavy calorie drinks for $5. Over 35 years ago the founder of Starbucks walked in his first location, driven to make the best roasted beans and serving the best tasting coffee. That foundation is long gone. "
            ],
            "upperSignalType": " ",
            "lowerSignalType": null
        },
        {
            "index": 47,
            "name": "The cups leak.",
            "shortName": "The cups leak.",
            "stage": "DRINKING & EATING",
            "occurence": 0.5,
            "positiveIntensity": 0,
            "negativeIntensity": -116,
            "average": -85,
            "positiveVerbatim": [],
            "negativeVerbatim": [],
            "upperSignalType": " ",
            "lowerSignalType": null
        },
        {
            "index": 48,
            "name": "I love Starbucks Reserve. It has more variety to chose from, and great atmosphere.",
            "shortName": "I love Starbucks Reserve. It has more variety to chose from, and great atmosphere.",
            "stage": "DRINKING & EATING",
            "occurence": 2.5,
            "positiveIntensity": 212,
            "negativeIntensity": 0,
            "average": 180,
            "positiveVerbatim": [],
            "negativeVerbatim": [],
            "upperSignalType": " ",
            "lowerSignalType": null
        },
        {
            "index": 49,
            "name": "Starbucks offers healthy options / there are not enough healthy choices or they are charged too much.",
            "shortName": "Starbucks offers healthy options / there are not enough healthy choices or they are charged too much.",
            "stage": "DRINKING & EATING",
            "occurence": 1.3,
            "positiveIntensity": 308,
            "negativeIntensity": -141,
            "average": 11,
            "positiveVerbatim": [
                "Lots of organic, vegan friendly, and kid friendly options as well! ",
                "Starbucks not only has a wide variety of great coffee but it has the most tasty and healthful food choices. "
            ],
            "negativeVerbatim": [],
            "upperSignalType": "goodPractice",
            "lowerSignalType": null
        },
        {
            "index": 50,
            "name": "Baristas make generous servings / my cup was not fully filled.",
            "shortName": "Baristas make generous servings / my cup was not fully filled.",
            "stage": "DRINKING & EATING",
            "occurence": 0.4,
            "positiveIntensity": 65,
            "negativeIntensity": -253,
            "average": 14,
            "positiveVerbatim": [],
            "negativeVerbatim": [
                "Over the past couple of years, I've noticed several things. First, the shots of espresso are not full anymore. Second, the cups are not full anymore. ",
                "When I order a venti skinny vanilla latte it is always never full - so much foam. Even when I inform the clerk no foam. When I receive the coffee it always has at least 1 inch or more of foam.",
                "When we order a grande or whatever, we expect a grande. Do not tell me it's because whip cream or milk can be added. Neither of us have any of it. It's extremely disappointing to pay over 5 dollars for coffee when I am not getting the expected size. ",
                "In the last couple weeks I start seeing my quad espresso getting half of the amount I usually was getting. When I asked, the coffee shop manager told me that Starbucks is changing the amount of the water in a single espresso shot. Now for the same money I'm getting less espresso."
            ],
            "upperSignalType": null,
            "lowerSignalType": "weakness"
        },
        {
            "index": 51,
            "name": "I enjoyed / I was disppointed by the food I ordered.",
            "shortName": "I enjoyed / I was disppointed by the food I ordered.",
            "stage": "DRINKING & EATING",
            "occurence": 8.7,
            "positiveIntensity": 157,
            "negativeIntensity": -106,
            "average": 20,
            "positiveVerbatim": [],
            "negativeVerbatim": [],
            "upperSignalType": " ",
            "lowerSignalType": null
        },
        {
            "index": 52,
            "name": "Being allergic, they never failed my drinks / I had problems with my allergies.",
            "shortName": "Being allergic, they never failed my drinks / I had problems with my allergies.",
            "stage": "DRINKING & EATING",
            "occurence": 0.7,
            "positiveIntensity": 10,
            "negativeIntensity": -90,
            "average": -63,
            "positiveVerbatim": [],
            "negativeVerbatim": [],
            "upperSignalType": " ",
            "lowerSignalType": null
        },
        {
            "index": 53,
            "name": "The Customer Service is great / poor.",
            "shortName": "The Customer Service is great / poor.",
            "stage": "CUSTOMER SERVICE",
            "occurence": 11,
            "positiveIntensity": 127,
            "negativeIntensity": -78,
            "average": -47,
            "positiveVerbatim": [
                "They always make sure you have a better experience next time when you call the customer service line and let them know what's going on. ",
                "I've had problems with being over charged in store at Starbucks but their customer service email representatives are always extremely helpful and willing to help me out."
            ],
            "negativeVerbatim": [
                "The stores can make their own rules which contrast with corporate policies and the Head Office don't even care about it.",
                "I realized Starbucks employees are not trained in technical issues and tell the customer whatever they can to get them off the phone. "
            ],
            "upperSignalType": " ",
            "lowerSignalType": null
        },
        {
            "index": 54,
            "name": "The hotline experience is smooth / painful.",
            "shortName": "The hotline experience is smooth / painful.",
            "stage": "CUSTOMER SERVICE",
            "occurence": 7.9,
            "positiveIntensity": 194,
            "negativeIntensity": -104,
            "average": -47,
            "positiveVerbatim": [
                "Wasn't really sure who to call so I called phone number I found on website. The Rep who answered the phone was so helpful and quick to resolve my issue. Very pleasant also. Great experience."
            ],
            "negativeVerbatim": [
                "I am left irritated, frustrated and disappointed. Every person I talked to seemed to be in a noisy place and distracted, none of them appeared as if they wanted to help. I am very disappointed to have received an experience like this from Starbucks. Starbucks you obviously need a better customer service training class !",
                "I called the phone # on the email and went through their horrible automated system that takes like 5 minutes to navigate. After locating the right department I was on hold for about 5 minutes just to hear the representative say I reached the wrong department. I was then placed on hold for about 15 minutes then spoke with a supervisor who then told me again that they couldn't help me and that she will attempt to transfer me to the correct party. Her 'attempt' was a failed one as all she did was blind transfer me to their automated queue only to go through another automated process of verifying who I am then I was on hold for about 40 minutes. ",
                "When calling Starbucks customer service, they need all sort of information, to corroborate that it is actually one of their products."
            ],
            "upperSignalType": "priority",
            "lowerSignalType": null
        },
        {
            "index": 55,
            "name": "The resolution is quick and easy / my problem is not resolved.",
            "shortName": "The resolution is quick and easy / my problem is not resolved.",
            "stage": "CUSTOMER SERVICE",
            "occurence": 2.6,
            "positiveIntensity": 182,
            "negativeIntensity": -98,
            "average": -62,
            "positiveVerbatim": [],
            "negativeVerbatim": [],
            "upperSignalType": " ",
            "lowerSignalType": null
        },
        {
            "index": 56,
            "name": "They don't trust my version of events.",
            "shortName": "They don't trust my version of events.",
            "stage": "CUSTOMER SERVICE",
            "occurence": 0.4,
            "positiveIntensity": 0,
            "negativeIntensity": -130,
            "average": -101,
            "positiveVerbatim": [],
            "negativeVerbatim": [],
            "upperSignalType": " ",
            "lowerSignalType": null
        },
        {
            "index": 57,
            "name": "It takes too much effort to deal with the Customer Service.        ",
            "shortName": "It takes too much effort to deal with the Customer Service.        ",
            "stage": "CUSTOMER SERVICE",
            "occurence": 0.4,
            "positiveIntensity": 0,
            "negativeIntensity": -263,
            "average": -149,
            "positiveVerbatim": [],
            "negativeVerbatim": [
                "Easily the worst customer service team in the nation - they are trained to repeat : \" I'm sorry but a district manager will have to follow up with you \". The employees are rude, ignorant, and lack professionalism of any kind. If you request to speak with someone higher up, they'll laugh. Oh, and here's the punch line - the district manager will never call you. It's simply a spin cycle to get you off the line. This entire Starbucks fatigue-scheme is designed to fatigue complaining customers. ",
                "Should a customer be made to call three times to ask to speak with a manager only to be once again ignored?",
                "I am so burned out from dealing with this company that I may never go back. I will make one more effort, and call the number they provided me ! I doubt that I'll get any type of satisfactory response. "
            ],
            "upperSignalType": null,
            "lowerSignalType": "weakness"
        },
        {
            "index": 58,
            "name": "Loyal customers get special care / are not valued.          ",
            "shortName": "Loyal customers get special care / are not valued.          ",
            "stage": "RELATIONSHIP ",
            "occurence": 5.6,
            "positiveIntensity": 123,
            "negativeIntensity": -90,
            "average": 13,
            "positiveVerbatim": [],
            "negativeVerbatim": [],
            "upperSignalType": " ",
            "lowerSignalType": null
        },
        {
            "index": 59,
            "name": "I love the rewards program  / your new program is a punishment.",
            "shortName": "I love the rewards program  / your new program is a punishment.",
            "stage": "RELATIONSHIP ",
            "occurence": 1.9,
            "positiveIntensity": 121,
            "negativeIntensity": -139,
            "average": -45,
            "positiveVerbatim": [],
            "negativeVerbatim": [
                "These are reason enough to go somewhere else. Let alone the company changing its free drink program so you have to spend a hefty dollar amount to get a free drink. I really think the company thinks we are all stupid !",
                "Starbucks is making a \" huge \" mistake when they introduced their new april 2016 policy change. Customers including myself are not supporting this change. Who are they kidding ! The other coffee companies are loving it... They will be getting Starbucks customers. Starbucks is not caring about their customers if they impose this outrageous plan. Lets be Americans and vote \" no change ! \" Thanks.",
                "When I found out today about the new Starbucks reward program, I couldn't believe it. I am not sure what marketing person came out with this idea but I would fire them. They are getting the public pretty fired up about this new program. Makes me sad. I once really thought that Starbucks was a great company that cared about its customers, apparently not."
            ],
            "upperSignalType": " ",
            "lowerSignalType": null
        },
        {
            "index": 60,
            "name": "I love the community feeling.",
            "shortName": "I love the community feeling.",
            "stage": "RELATIONSHIP ",
            "occurence": 1.1,
            "positiveIntensity": 129,
            "negativeIntensity": 0,
            "average": 106,
            "positiveVerbatim": [],
            "negativeVerbatim": [],
            "upperSignalType": " ",
            "lowerSignalType": null
        },
        {
            "index": 61,
            "name": "Overall, the quality of service is great / poor.",
            "shortName": "Overall, the quality of service is great / poor.",
            "stage": "IMAGE & PERCEPTIONS",
            "occurence": 22.7,
            "positiveIntensity": 227,
            "negativeIntensity": -104,
            "average": 10,
            "positiveVerbatim": [],
            "negativeVerbatim": [],
            "upperSignalType": " ",
            "lowerSignalType": null
        },
        {
            "index": 62,
            "name": "Starbucks values customers / customers are poorly valued.",
            "shortName": "Starbucks values customers / customers are poorly valued.",
            "stage": "IMAGE & PERCEPTIONS",
            "occurence": 12.7,
            "positiveIntensity": 144,
            "negativeIntensity": -105,
            "average": 28,
            "positiveVerbatim": [
                "Starbucks does a great job of getting to know its repeat customers, their regular orders, and calling them by name. They make you feel like a valued customer!",
                "Starbucks may seem high priced to some but they go above and beyond to make the customer feel special and appreciated. ",
                "I had an experience today where the full chain in our area had their computer system down since this morning and could not take orders. The store was giving out free small coffee or tea at no charge to anyone who stopped by. We went to 2 stores thinking it was just the one location and both were doing this. This shows they appreciate their customers. think how much money they are losing in sales and free product but they still want the customers to be compensated for stopping at their store. They earned a life long customer from me today ! "
            ],
            "negativeVerbatim": [
                "I realize they are a business, but they always had a way of ringing in the Christmas cheer with their cute cups, decor and friendly smiles. Now it's boring and the only focus is consumerism.",
                "Gold membership for everyone that steps in and makes a purchase in April? Wow, are you freaking kidding me? Do you realize how much money the average gold card holder spent to get to that level with your company? It's ghastly that you don't value that loyalty. Through your promotion you have demonstrated to all of us that loyalty means no more to you than someone that has never done business with you. That is absolutely shameful and I hope your profits reflect this alienation of your loyal customer base. Starbucks has long been a symbol of excess but now to me is a symbol of arrogance and disregard for its customers. I look forward to supporting local coffee shops and other larger retailers moving forward."
            ],
            "upperSignalType": "priority",
            "lowerSignalType": null
        },
        {
            "index": 63,
            "name": "Starbucks is above / below competition.         ",
            "shortName": "Starbucks is above / below competition.         ",
            "stage": "IMAGE & PERCEPTIONS",
            "occurence": 1.8,
            "positiveIntensity": 174,
            "negativeIntensity": -97,
            "average": 45,
            "positiveVerbatim": [],
            "negativeVerbatim": [],
            "upperSignalType": " ",
            "lowerSignalType": null
        },
        {
            "index": 64,
            "name": "Starbucks cares for the environment / should work harder on recycling.",
            "shortName": "Starbucks cares for the environment / should work harder on recycling.",
            "stage": "IMAGE & PERCEPTIONS",
            "occurence": 0.4,
            "positiveIntensity": 113,
            "negativeIntensity": -20,
            "average": 87,
            "positiveVerbatim": [],
            "negativeVerbatim": [],
            "upperSignalType": " ",
            "lowerSignalType": null
        }
    ],
    "name": "USA Customer Experience",
    "isKpamRH": false,
    "isComparative": false,
    "pdfDocumentPath": null,
    "reportDocumentPath": null,
    "fichiers": false,
    "customerId": 4,
    "hasPdfDocument": false,
    "hasReportDocument": false
}
export {
    fake, fakeUS
}